import type { zh } from "./zh";

/**
 * German. Kept complete and typed against the Chinese table, but not
 * offered by the switcher (OFFERED in index.ts) until someone reads it:
 * every string here is a second thing to keep true.
 */
export const de: Record<keyof typeof zh, string> = {
  "nav.label": "Hauptnavigation",
  "nav.overview": "Übersicht",
  "nav.jobs": "Stellen",
  "nav.companies": "Firmen",
  "nav.interviews": "Gespräche",
  "nav.me": "Mein Profil",
  "nav.agent": "Agent",
  "nav.collapse": "Einklappen",
  "nav.expand": "Ausklappen",
  "nav.loading": "Lädt...",
  "nav.cardFailed": "Die Karte konnte nicht geöffnet werden. Bitte versuche es erneut.",
  "nav.areaFailed": "Konnte nicht geladen werden. Bitte versuche es erneut.",
  "nav.offline": "Du bist offline. Verbinde dich erneut und versuche es noch einmal.",
  "nav.slow": "Lädt noch, langsamer als sonst...",
  "nav.failed": "Beim Laden der Seite ist ein Fehler aufgetreten. Bitte versuche es erneut.",
  "nav.dismiss": "Schließen",
  "theme.toDark": "Zur Nachtansicht",
  "theme.toLight": "Zur Tagansicht",
  "lang.label": "Sprache",
  "help.label": "Hilfe & Kontakt",
  "help.lede": "Etwas klappt nicht, oder eine Idee? Schreib uns:",
  "help.copy": "Kopieren",
  "help.copied": "Kopiert",
  "help.copyByHand": "Kopieren hat nicht geklappt; die Adresse ist markiert, bitte von Hand kopieren.",
  "auth.support": "Probleme? Schreib an",
  "fold.open": "Öffnen →",

  "chat.new": "Neues Gespräch",
  "chat.expand": "Gespräch öffnen",
  "chat.min": "Ausblenden",
  "chat.dock": "Rechts andocken",
  "chat.undock": "Andocken aufheben",
  "chat.dockNarrow": "Andocken braucht einen breiteren Bildschirm",
  "chat.resizeW": "Breite des Gesprächs",
  "chat.resizeH": "Höhe des Gesprächs",
  "chat.end": "Beenden und Wichtiges festhalten",
  "chat.endMock": "Interview beenden und Fazit hören",
  "chat.endAsk": "Diese Sitzung beenden? Ich halte das Besprochene in Ihrem Profil fest – das dauert etwa zehn Sekunden. Danach beginnt eine neue Sitzung.",
  "chat.endAskMock": "Dieses Übungsinterview beenden? Sie bekommen ein Fazit – das dauert etwa zehn Sekunden.",
  "chat.cancel": "Abbrechen",
  "chat.endOk": "Beenden",
  "chat.title": "Neues Gespräch",
  "chat.sub": "Jederzeit fragen",
  "chat.opener": "Womit kann ich helfen? Wo wollen Sie anfangen?",
  "chat.placeholder": "Etwas fragen…",
  "chat.send": "Senden",
  "chat.attach": "Anhängen",
  "chat.attachKinds": "PDF, Word-, Excel- oder PowerPoint-Datei, .txt oder .md, oder ein Bild anhängen",
  "chat.attachFailed": "Diese Datei ging nicht durch.",
  "chat.hereIsFile": "Sieh dir das an.",
  "chat.afterActions": "Das oben habe ich notiert. Antworten Sie kurz, dann mache ich weiter.",
  "chat.cutCeiling": "Die Antwort war zu lang und wurde abgeschnitten. Antworten Sie „weiter“, dann mache ich da weiter, wo sie aufgehört hat.",
  "chat.cutStopped": "Diese Antwort wurde mittendrin gestoppt. Formulieren Sie die Frage bitte anders.",
  "chat.drop": "Zum Anhängen loslassen",
  "chat.remove": "Entfernen",
  "chat.cvSaved": "Als Lebenslauf gespeichert: %1",
  "chat.tailorProposed": "Vorgeschlagene Änderungen: %1 (davon Erweiterungen: %2)",
  "chat.tailorDecided": "Angenommen: %1 (davon Erweiterungen: %2), abgelehnt: %3",
  "chat.cvReplaced": "Als Lebenslauf gespeichert: %1, ersetzt %2",
  "chat.cvReread": "Ich lese Ihren Lebenslauf erneut: %1",
  "chat.tooMany": "Höchstens %1 Dateien auf einmal",
  "modal.close": "Schließen",
  "modal.cancel": "Abbrechen",
  "modal.gone": "Das hier gibt es nicht mehr.",
  "thread.mock": "Probe · %1",
  "thread.tailor": "Lebenslauf · %1",
  "thread.interview": "Interview · %1",
  "thread.profile": "Profil",
  "thread.criteria": "Regeln",
  "thread.draft": "Drafting · %1 · %2",
  "thread.draftLoose": "Drafting · %1",
  "thread.free": "Neues Gespräch",
  "thread.untitled.opening": "Eine Stelle",
  "thread.untitled.company": "Ein Arbeitgeber",
  "thread.untitled.interview": "Ein Gespräch",
  "thread.untitled.mock": "Ein Übungsgespräch",
  "thread.untitled.tailor": "Eine Lebenslauf-Anpassung",
  "thread.channel.whatsapp": "WhatsApp",
  "thread.channel.slack": "Slack",
  "thread.channel.telegram": "Telegram",
  "chan.endWord": "Sitzung beenden",
  "chan.endHint": "(Schick „Sitzung beenden“, um diese Sitzung zu beenden.)",
  "chan.ended": "Sitzung beendet.",
  "chan.endedIdle": "Diese Sitzung wurde beendet, weil keine weitere Antwort kam.",
  "chan.nothingToEnd": "Es läuft keine Sitzung.",
  "chan.wrote": "Notiert: %1",
  "chan.learned": "%1 Regel(n) warten auf deine Bestätigung auf der Website: %2",
  "chan.unknown": "Dieser Chat ist mit keinem Konto verbunden. Verbinde ihn unter Ich → Einstellungen: %1",
  "chan.many": "Dieser Chat hängt an mehr als einem Konto; lass ihn in den Einstellungen nur an einem.",
  "chan.off": "Chat ist hier nicht eingeschaltet. Schalte ihn in den Einstellungen ein: %1",
  "chan.trialOver": "Deine Probewoche ist vorbei; sieh auf der Website nach: %1",
  "chan.failed": "Darauf konnte nicht geantwortet werden; schick es gleich noch einmal.",
  "chan.badFile": "Diese Datei konnte nicht angenommen werden: %1",
  "chan.onlyThese": "Gelesen werden nur Text, PDFs und Bilder.",
  "me.set.ch.chat": "Chat",
  "me.set.ch.chatHint": "Wenn an, beantwortet der Agent Nachrichten von hier; „Sitzung beenden“ schließt eine Sitzung.",
  "chan.slack.noFiles": "Dateien bitte auf der Website oder in WhatsApp schicken; hier wird nur Text gelesen.",
  "me.set.ch.wa.lede": "Nach dem Verbinden kannst du in WhatsApp direkt mit dem Agenten chatten (Benachrichtigungen kommen noch nicht); verbinden heißt, vom Handy einen Code zu schicken.",
  "me.set.ch.wa.connect": "WhatsApp verbinden",
  "me.set.ch.wa.unavailable": "Diese Installation hat noch keine WhatsApp-Nummer; nichts zum Verbinden.",
  "me.set.ch.tg.lede": "Nachrichten kommen in Telegram mit Knöpfen: jede Stelle im Morgenbericht direkt beantworten (bewerben / merken / passt nicht), und auf eine Frage einfach antworten; dort kannst du auch mit dem Agenten chatten. Verbinden heißt einmal Start in Telegram drücken.",
  "me.set.ch.tg.connect": "Telegram verbinden",
  "me.set.ch.tg.open": "In Telegram auf Start drücken",
  "me.set.ch.tg.valid": "Noch %1 Minuten gültig; nach Start diese Seite neu laden.",
  "me.set.ch.tg.unavailable": "Diese Installation hat noch keinen Telegram-Bot; nichts zum Verbinden.",
  "me.set.ch.tg.connected": "Dein Telegram",
  "me.set.ch.wa.open": "Code in WhatsApp senden",
  "me.set.ch.wa.code": "Oder schick diesen Code an die Nummer oben: %1",
  "me.set.ch.wa.valid": "Noch %1 Minuten gültig; danach diese Seite neu laden.",
  "chan.wa.linked": "Verbunden: diese Nummer gehört jetzt zum Konto %1 und kann mit dem Agenten chatten; „Sitzung beenden“ schließt eine Sitzung.",
  "chan.wa.expired": "Dieser Verbindungscode ist abgelaufen oder schon benutzt. Geh zurück zu Ich → Einstellungen und drück noch einmal „WhatsApp verbinden“.",
  "chan.wa.conflict": "Diese Telefonnummer gehört bereits zu einem anderen Counting-AI-Konto und kann nicht übertragen werden. Nutzen Sie dort die Anmeldung oder die Kontowiederherstellung per E-Mail.",
  "chan.tg.linked": "Verbunden: dieses Telegram gehört jetzt zum Konto %1. Morgenbericht und Fragen kommen hierher, und du kannst mit dem Agenten chatten; „Sitzung beenden“ schließt eine Sitzung. Was geschickt wird, wählst du unter Ich → Einstellungen.",
  "chan.tg.expired": "Dieser Verbindungscode ist abgelaufen oder schon benutzt. Geh zurück zu Ich → Einstellungen und drück noch einmal „Telegram verbinden“.",
  "chan.tg.conflict": "Dieses Telegram ist schon mit einem anderen Counting-AI-Konto verbunden und kann nicht verschoben werden. Entferne es zuerst in den Einstellungen dieses Kontos und verbinde es dann hier.",
  "chan.tg.hello": "Hier kommen die Nachrichten von Counting AI. Zum Verbinden unter Ich → Einstellungen „Telegram verbinden“ drücken: %1",

  "kind.all": "Alle",
  "kind.opening": "Stellen",
  "kind.company": "Firmen",
  "kind.interview": "Interviews",
  "kind.mock": "Proben",
  "kind.tailor": "Lebenslauf",
  "kind.meta": "Profil · Regeln",
  "kind.profile": "Profil",
  "kind.criteria": "Regeln",
  "kind.free": "Gespräch",
  "agent.search": "Gespräche suchen…",
  "agent.newThread": "+ Neues Gespräch",
  "agent.today": "Heute",
  "agent.week": "Diese Woche",
  "agent.earlier": "Früher",
  "agent.none": "Keine passenden Gespräche",
  "agent.pick": "Ein Gespräch wählen oder ein neues beginnen.",
  "agent.unread": "Neue Antwort",
  "agent.open.opening": "Diese Stelle öffnen →",
  "agent.open.company": "Firmenkarte öffnen →",
  "agent.open.interview": "Vorbereitung öffnen →",
  "agent.open.profile": "Profil öffnen →",
  "agent.open.criteria": "Regeln öffnen →",
  "agent.mockPlaceholder": "Auf Englisch antworten… („auf Chinesisch“ wechselt die Runde, „Ende“ gibt das Fazit)",
  "agent.folded": "Vorherige %1 Runden zusammengefasst · aufklappen",
  "agent.ended": "Sitzung beendet %1",
  "agent.endedNothing": "Diesmal nichts zu notieren.",
  "agent.more": "%1 frühere Nachrichten",
  "agent.loading": "Lädt…",
  "agent.thinking": "Denke nach…",
  "agent.looking": "Lese:",
  "agent.failed": "Das hat nicht geklappt. Nochmal?",
  "agent.endFailed": "Sitzung konnte nicht beendet werden; noch einmal.",
  "agent.ending": "Sitzung wird beendet, das Besprochene kommt in Ihr Profil…",
  "agent.endingMock": "Das Fazit wird geschrieben…",
  "agent.capped": "Nur die letzten 100; die Suche findet ältere.",
  "opener.opening": "%1 · %2%3",
  "opener.askThis": "Zu dieser fragen",
  "opener.notNow": "Jetzt nicht",
  "opener.company": "%1 · passende offene Stellen: %2 · Visum: %3",
  "opener.askCompany": "Lohnt sich das Verfolgen?",
  "opener.interview": "%1 von 4 Vorbereitungsteilen bereit.",
  "opener.missing": "Fehlt: %1.",
  "opener.askPress": "Die kritischen Punkte durchgehen",
  "opener.mock": "Probeinterview, %1 von 4 Teilen vorbereitet. Sagen Sie „Start“, dann kommt die erste Frage.",
  "opener.tailor": "Lebenslauf für „%1“ anpassen. Sagen Sie „Start“, dann gehe ich die Anforderungen und das Urteil der zwei simulierten Screener durch und schlage Änderungen Zeile für Zeile vor.",
  "opener.tailorKept": "Diese Überarbeitung für „%1“ beruht auf einem früheren Lebenslauf und bleibt, wie sie war: Sie können die Endfassung lesen und herunterladen. Um weiterzuarbeiten, beginnen Sie auf der Seite eine neue Überarbeitung für diese Stelle.",
  "opener.start": "Start",
  "opener.profile": "Was Sie hier über sich sagen, kommt ins Profil.",
  "opener.criteria": "Hier geänderte Regeln gelten ab dem nächsten Lauf.",
  "opener.rules": "Ein paar Regeln warten auf Ihre Bestätigung.",
  "opener.pending": "Ein paar Dinge warten noch auf Sie.",
  "prep.deep": "Recherche",
  "action.confirm.learned.yes": "Regel behalten",
  "action.confirm.learned.no": "Verwerfen",
  "action.confirm.before": "Schon früher beantwortet; nichts geändert",

  "status.maybe": "gemerkt",
  "status.passed": "aussortiert",
  "status.preparing": "vorgemerkt",
  "status.applied": "beworben",
  "status.interview_requested": "eingeladen",
  "status.interviewing": "im Gespräch",
  "status.offer": "Angebot",
  "status.rejected": "Absage",

  "level.high": "Passt gut",
  "level.mid": "Passt teils",
  "level.low": "Passt wenig",
  "level.unrated": "Nicht bewertet",

  "flag.visa": "Visum",
  "flag.lang": "Sprache",
  "flag.move": "Ort",
  "flag.salary": "Gehalt",
  "basis.stated": "genannt",
  "basis.inferred": "vermutet",
  "basis.unknown": "nicht genannt",
  "card.flagNone": "Die Anzeige sagt dazu nichts.",
  "visa.stated_yes": "unterstützt",
  "visa.likely": "vermutlich",
  "visa.unknown": "unbekannt",
  "visa.stated_no": "keine Unterstützung",
  "local.none": "keine fehlende Sprache",
  "local.plus": "Landessprache ein Plus",
  "local.required": "verlangt eine fehlende Sprache",
  "local.unknown": "nicht genannt",
  "move.no_move": "kein Umzug",
  "move.remote_home": "remote im Land",
  "move.in_country": "im Land",
  "move.move_home": "Umzug im Land",
  "move.remote_abroad": "remote im Ausland",
  "move.move_abroad": "Umzug ins Ausland",
  "move.unknown": "nicht genannt",
  "pay.clears_threshold": "über Schwelle",
  "pay.below_threshold": "unter Schwelle",
  "pay.not_stated": "nicht genannt",
  "mode.remote": "remote",
  "mode.hybrid": "hybrid",
  "mode.onsite": "vor Ort",
  "mode.unclear": "nicht angegeben",

  "card.original": "Original ↗",
  "card.undo": "Rückgängig",
  "card.why": "Warum Sie",
  "card.concerns": "Meine Bedenken",
  "card.goApply": "Bewerben",
  "card.goApplyArrow": "Bewerben →",
  "card.save": "Später",
  "card.notFor": "Passt nicht",
  "card.tailor": "Lebenslauf für diese Stelle anpassen",
  "card.tailorOthers": "Weitere Überarbeitungen",
  "card.tailorEdited": "Zuletzt bearbeitet: %1",
  "card.tailorStale": "auf einem früheren Lebenslauf",
  "card.tailorView": "Angepassten Lebenslauf ansehen",
  "card.tailoredFold": "Angepasster Lebenslauf",
  "tailor.title": "Lebenslauf anpassen",
  "tailor.back": "← Zurück zur Stelle",
  "tailor.return": "← Zurück",
  "tailor.backAgent": "← Agent",
  "tailor.strength.nudge": "Stärke: nur Formulierung",
  "tailor.strength.keywords": "Stärke: Begriffe der Anzeige",
  "tailor.strength.full": "Stärke: umfassend",
  "tailor.all": "Alle annehmen (%1)",
  "tailor.allExpansions": "Alle annehmen (%1; davon Erweiterungen: %2)",
  "tailor.none": "Noch keine Änderungen. Sagen Sie im Gespräch „Start“: Zuerst werden die Anforderungen gelesen, dann kommen Änderungen einzeln, jede zum Annehmen oder Ablehnen.",
  "tailor.accept": "Annehmen",
  "tailor.reject": "Ablehnen",
  "tailor.withdraw": "Zurücknehmen",
  "tailor.reaccept": "Doch annehmen",
  "tailor.working.accept": "Wird angenommen…",
  "tailor.working.reject": "Wird abgelehnt…",
  "tailor.working.withdraw": "Wird zurückgenommen…",
  "tailor.working.reaccept": "Wird angenommen…",
  "tailor.working.all": "Alle werden angenommen…",
  "tailor.state.proposed": "Offen",
  "tailor.state.accepted": "Angenommen",
  "tailor.state.rejected": "Abgelehnt",
  "tailor.expansion": "Erweiterung",
  "tailor.expansionWhy": "Das steht nicht im Lebenslauf; bitte vor dem Annehmen prüfen, ob es stimmt.",
  "tailor.src.resume": "Quelle: Lebenslauf %1",
  "tailor.src.said": "Quelle: am %1 im Gespräch gesagt: „%2“",
  "tailor.src.none": "Quelle: nicht im Lebenslauf",
  "tailor.serves": "Zu Anforderung %1",
  "tailor.flag.term": "Neuer Name: %1",
  "tailor.flag.number": "Neue Zahl: %1",
  "tailor.flag.year": "Neues Jahr: %1",
  "tailor.flag.authorship": "Fremde Arbeit als eigene: %1",
  "tailor.flag.cited": "Stützt sich auf eine andere Position",
  "tailor.flag.said": "Diese Worte stehen nicht im Gespräch",
  "tailor.flag.skills": "Entfernt Fähigkeiten",
  "tailor.flag.long": "Viel länger als die Zeile",
  "tailor.act.replace": "Geändert",
  "tailor.act.add": "Hinzugefügt",
  "tailor.act.remove": "Entfernt",
  "tailor.act.move": "Verschoben hinter %1",
  "tailor.fact": "Faktenzeile (Arbeitgeber, Titel, Daten): wird nicht umgeschrieben",
  "tailor.section.summary": "Profil",
  "tailor.section.experience": "Berufserfahrung",
  "tailor.section.education": "Ausbildung",
  "tailor.section.skills": "Kenntnisse",
  "tailor.section.publications": "Publikationen",
  "tailor.section.other": "Sonstiges",
  "tailor.view.merged": "Zusammen",
  "tailor.view.split": "Nebeneinander",
  "tailor.was": "Vorher",
  "tailor.now": "Nachher",
  "tailor.reqs": "Anforderung für Anforderung",
  "tailor.reqsNote": "Zwei simulierte Screener prüfen je Anforderung, ob der Lebenslauf sie belegt. Keine Gesamtnote.",
  "tailor.reqsNone": "Die Anforderungen sind noch nicht gelesen. Sagen Sie im Gespräch „Start“.",
  "tailor.before": "Vorher",
  "tailor.after": "Nachher",
  "tailor.screener": "Screener %1",
  "tailor.recheck": "Erneut prüfen",
  "tailor.checking": "Wird erneut geprüft…",
  "tailor.checkFailed": "Die Prüfung ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "tailor.notYet": "Nicht geprüft",
  "tailor.must": "Muss",
  "tailor.nice": "Wünschenswert",
  "tailor.verdict.evidence": "Belegt",
  "tailor.verdict.weak": "Erwähnt",
  "tailor.verdict.none": "Fehlt",
  "tailor.verdict.unknown": "Keine Antwort",
  "tailor.stale": "Diese Überarbeitung beruht auf einem früheren Lebenslauf. Unten steht ihre damalige Endfassung, die Sie herunterladen können. Um sie mit Ihrem aktuellen Lebenslauf zu bearbeiten, beginnen Sie neu.",
  "tailor.noOutline": "Der Lebenslauf muss noch einmal gelesen werden, bevor er hier zeilenweise erscheint.",
  "tailor.pdfNote": "Ihr Lebenslauf liegt als PDF vor: Beim Export wird er einspaltig neu gesetzt, nicht wie das Original. Ein Word-Original wird direkt bearbeitet.",
  "tailor.posting": "Die Anzeige",
  "tailor.sr.gone": "Entfernt: ",
  "tailor.sr.new": "Hinzugefügt: ",
  "tailor.aria.accept": "Änderung an %1 annehmen",
  "tailor.aria.reject": "Änderung an %1 ablehnen",
  "tailor.aria.withdraw": "Änderung an %1 zurücknehmen",
  "tailor.aria.reaccept": "Änderung an %1 doch annehmen",
  "tailor.restart": "Für diese Stelle neu beginnen",
  "tailor.afterOld": "Die Spalten „Nachher“ wurden vor späteren Entscheidungen geprüft und sind vielleicht veraltet. Bitte erneut prüfen.",
  "tailor.export": "Word herunterladen (überarbeitet)",
  "tailor.exportFirst": "Vor dem Download erneut prüfen",
  "tailor.exportNone": "Nehmen Sie ein paar Änderungen an, dann können Sie es herunterladen.",
  "tailor.exportPdfNew": "PDF herunterladen (überarbeitet)",
  "tailor.exportingWord": "Word-Datei wird vorbereitet…",
  "tailor.exportingPdf": "PDF wird gesetzt…",
  "tailor.exportNewNote": "Ihr Lebenslauf liegt als PDF vor und lässt sich nicht direkt bearbeiten: Diese beiden sind Ihre eigenen Worte, neu gesetzt. Der Inhalt ist Ihrer, das Layout unseres. Die Word-Datei können Sie weiterbearbeiten.",
  "tailor.refusedNotOffered": "Dieses Format wird für diesen Lebenslauf nicht angeboten.",
  "tailor.missedOne": "1 übernommene Änderung ließ sich nicht in die Word-Datei schreiben (diese Zeile steht in einer Tabelle oder hinter einem Tabulator); in der Datei fehlt sie:",
  "tailor.missedMany": "%1 übernommene Änderungen ließen sich nicht in die Word-Datei schreiben (diese Zeilen stehen in einer Tabelle oder hinter einem Tabulator); in der Datei fehlen sie:",
  "tailor.refusedUnread": "Der Lebenslauf wurde noch nicht in Zeilen eingelesen.",
  "tailor.refusedNoFile": "Es liegt kein Lebenslauf vor, in den die Änderungen geschrieben werden könnten. Laden Sie zuerst einen hoch.",
  "tailor.refusedBroken": "Die Word-Datei liest sich nicht mehr wie der eingelesene Lebenslauf (sie wurde vielleicht zwischenzeitlich bearbeitet). Laden Sie sie erneut hoch oder beginnen Sie neu.",
  "tailor.exportFailed": "The file could not be made — the fault is on our side, not in your CV. Try again in a moment.",
  "tailor.refusedBlank": "Die Schrift des PDFs kann diese Zeilen gar nicht setzen — sie blieben leer: %1. Nutzen Sie die Word-Datei (sie verwendet die Schriften des Lesers) oder schreiben Sie diese Zeilen mit Zeichen, die diese Schrift kennt.",
  "tailor.refusedUnchecked": "Diese Fassung ist noch nicht geprüft: Seit der letzten Prüfung hat sich eine Entscheidung geändert. Erst erneut prüfen, dann herunterladen.",
  "tailor.damagedOne": "1 Bestandteil dieser Word-Datei lässt sich nicht öffnen (vermutlich beim Übertragen oder Speichern beschädigt, nicht durch diese Überarbeitung). Er wird unverändert in die exportierte Datei übernommen, Ihr Text bleibt davon unberührt; Word kann ihn möglicherweise nicht anzeigen:",
  "tailor.damagedMany": "%1 Bestandteile dieser Word-Datei lassen sich nicht öffnen (vermutlich beim Übertragen oder Speichern beschädigt, nicht durch diese Überarbeitung). Sie werden unverändert in die exportierte Datei übernommen, Ihr Text bleibt davon unberührt; Word kann sie möglicherweise nicht anzeigen:",
  "tailor.lostGlyphs": "Diese Zeichen kann das PDF nicht setzen — die verwendete Schrift kennt sie nicht: %1. Betroffene Zeilen: %2. Die Word-Datei enthält sie; sie nutzt die Schriften des Lesers.",
  "tailor.refusedUnreadable": "Aus diesem Lebenslauf ließ sich kein Text lesen — ein früheres Einlesen wurde abgelehnt. Laden Sie eine andere Datei hoch und exportieren Sie erneut.",
  "tailor.refusedMismatch": "Der Text des Lebenslaufs passt nicht mehr zu den eingelesenen Zeilen — meist ein gerade hochgeladener, noch nicht eingelesener Lebenslauf. Warten Sie das Einlesen ab oder beginnen Sie neu.",
  "tailor.exportNote": "Sie erhalten Ihre eigene Datei, in der nur die angenommenen Zeilen neu formuliert sind: Layout, Schriften und Kopfzeile bleiben unverändert.",
  "tailor.smellsTitle": "Vor dem Senden ein Blick",
  "tailor.smellAi": "%1: „%2“ klingt nach einem Modell",
  "tailor.smellCoach": "%1: „%2“ sagt nicht, was Sie getan haben",
  "card.passPlaceholder": "Ein Satz, damit ich lerne",
  "card.passSubmit": "Absenden",
  "card.plugin": "Die Erweiterung füllt auf der Bewerbungsseite aus, was sie kann, und markiert den Rest.",
  "card.closesOn": "Frist %1.",
  "card.changedHead": "Der Arbeitgeber hat diese Anzeige geändert",
  "card.changedTitle": "sie heißt jetzt „%1“",
  "card.changedPlace": "sie ist jetzt in %1",
  "card.changedText": "der Text wurde großteils neu geschrieben",
  "card.changedJoin": "; ",
  "card.changedEnd": ". Maßgeblich ist die Seite des Arbeitgebers.",
  "card.closedTitle": "Diese Anzeige wurde entfernt",
  "card.closedApply": "Vom Arbeitgeber entfernt (bemerkt: %1); die Bewerbung geht womöglich nicht mehr.",
  "card.closedSent": "Vom Arbeitgeber entfernt (bemerkt: %1); Bewerbungen werden womöglich nicht mehr bearbeitet.",
  "card.closedRunning": "Anzeige vom Arbeitgeber entfernt (bemerkt: %1); ob es weitergeht, sagt dir der Arbeitgeber.",
  "card.markApplied": "Als beworben markieren",
  "card.notes": "Notizen",
  "card.notesPlaceholder": "Nur für Sie",
  "card.unsave": "Nicht mehr merken",
  "card.dequeue": "Aus der Liste nehmen",
  "card.sentDays": "Vor %1 Tagen gesendet · %2",
  "card.noReply": "Noch keine Antwort.",
  "card.replyAsk": "Ich habe eine E-Mail von %1 gelesen, die wie eine Antwort aussieht. Was sagen sie?",
  "card.yes": "Ja",
  "card.no": "Nein",
  "card.gotInvite": "Einladung erhalten →",
  "card.rejected": "Absage",
  "card.otherTime": "Anderer Termin",
  "card.strategy": "Strategie",
  "card.skills": "Fähigkeiten",
  "card.accounts": "Erfahrungsberichte",
  "card.have": "Vorhanden",
  "card.adjacent": "Angrenzend",
  "card.gap": "Lücke",
  "card.mock": "Probegespräch →",
  "card.interviewStarted": "Gespräch begonnen",
  "card.gotOffer": "Angebot erhalten",
  "card.timeline": "Dieser Prozess",
  "card.replyBy": "Antwort bis %1.",
  "card.openCompare": "Vergleich öffnen →",
  "ask.compare": "Hilf mir, meine Angebote zu vergleichen.",
  "card.prepFold": "Interviewvorbereitung",
  "card.scoreHow": "Zehn Urteile, nach Ihrer Gewichtung zusammengesetzt, von 100.",
  "card.scoreWeights": "Wie ich sortiere →",

  // ⓘ beside a number: the button's name for a screen reader (#238)
  "tip.score": "Was diese Zahl bedeutet",
  "tip.closing": "Was diese Zahl zählt",
  "tip.scan": "Was diese Zahlen sind",
  "tip.ledger": "Wie diese Zahlen gezählt werden",
  "tip.unrated": "Was „nicht bewertet“ bedeutet",
  "tip.gone": "Was „entfernt“ bedeutet",
  "tip.track": "Wie diese Zählungen entstehen",
  "tip.report": "Was diese Versionen bedeuten",
  "tip.week": "Wie die beiden Spalten gezählt werden",
  "tip.accounts": "Quellen und Suchhinweise zu den Erfahrungsberichten",
  "tip.deepSources": "Quellen der Tiefenrecherche",
  "card.endedNote": "Erscheint nicht mehr vorne.",
  "card.judgmentFold": "Einschätzung",
  "card.companyLink": "Firma · Visumbilanz →",
  "card.posting": "Originale Stellenbeschreibung",
  "card.postingMore": "Weiterlesen",
  "card.postingLess": "Weniger anzeigen",
  "card.translated": "Übersetzt",
  "card.translating": "Wird übersetzt…",
  "card.tooLongToTranslate": "Zu lang zum Übersetzen",
  "card.untranslatable": "Nicht übersetzbar",
  "card.threadFold": "Gespräch zu dieser Stelle",
  "card.continue": "Weiter…",
  "card.seenOn": "Auf %1 Portalen gesehen: %2",
  "reason.stack": "Stack passt nicht",
  "reason.too_senior": "Zu senior",
  "reason.too_junior": "Zu junior",
  "reason.location": "Ort",
  "reason.pay": "Gehalt",
  "reason.size": "Firmengröße",
  "reason.unsure": "Unklar",

  "co.following": "Verfolgt",
  "co.declined": "Abgelehnt",
  "co.unreachable": "Nicht lesbar",
  "co.set_aside": "Aussortiert",
  "co.setAsideOn": "Deine harten Kriterien haben jede Stelle dort beiseitegelegt.",
  "co.followUp": "Verfolgen",
  "co.noBoardYet": "Noch kein Stellenportal gefunden",
  "co.unfollowNow": "Nicht mehr verfolgen",
  "co.tryAgain": "Nochmal versuchen",
  "co.siteEdit": "Adresse der Karriereseite…",
  "co.openCareers": "Karriereseite öffnen ↗",
  "co.lookCareers": "Karriereseite ansehen ↗",
  "co.ats": "ATS",
  "ats.page": "Karriereseite",
  "ats.sitemap": "Karriereseite (Sitemap)",
  "ats.lever_eu": "lever (EU)",
  "co.open": "Offen",
  "co.openCount": "%1 offen, davon %2 passend",
  "co.sponsorship": "Visumsunterstützung",
  "co.sponsorshipScope": "pro Firma · für alle Nutzer",
  "co.evidence": "Beleg",
  "co.basics": "Eckdaten",
  "co.size": "Größe",
  "co.stage": "Phase",
  "co.hq": "Sitz",
  "co.inYourCity": "In Ihrer Stadt",
  "co.workingLang": "Arbeitssprache",
  "co.remote": "Remote",
  "co.unstated": "Nicht genannt",
  "co.openForYou": "Offen · passend",
  "co.of": "von",
  "co.openOnJobs": "Die passenden stehen auf der Stellenseite.",
  "co.openArrow": "Öffnen →",
  "co.record": "Mein Verlauf",
  "co.noRecord": "Noch kein Kontakt mit dieser Firma.",
  "co.related": "Verwandte Firmen",
  "co.notFollowed": "nicht verfolgt",
  "co.deep": "Recherche",
  "co.deepWhen": "erst bei einem Gespräch · recherchiert am %1",
  "co.deepWait": "Sobald es ein Gespräch gibt, recherchiere ich: Produkt, Technik, Team, Risiken, gute Fragen.",
  "co.notResearched": "Diese Firma wurde noch nicht recherchiert.",
  "co.notResearchedBasics": "Diese Firma wurde noch nicht recherchiert; unten stehen nur die erfassten Eckdaten.",
  "co.product": "Produkt",
  "co.money": "Geschäftsmodell",
  "co.tech": "Technik",
  "co.team": "Team",
  "co.risks": "Risiken",
  "co.ask": "Gute Fragen",
  "co.thread": "Firmengespräch",
  "co.note": "Ihre Notiz",
  "co.notePlaceholder": "Nur für Sie…",
  "co.stated": "genannt",
  "co.guessed": "vermutet",
  "co.noSuggest": "Wir verfolgen sie nicht mehr für Sie.",
  "co.retryHint": "Wenn du ihre echte Karriereseite kennst, trag sie oben ein und versuch es noch einmal.",
  "co.unreadable": "Gefunden, aber die Stellen auf der Karriereseite kann ich nicht lesen.",
  "co.relook": "Ich schaue jede Woche wieder nach, und in der Nacht, in der das System angebunden wird.",

  // the companies page (block 4b): the rail, the rows, the residue
  "co.added": "von Ihnen ergänzt",
  "co.ours": "für Sie verfolgt",
  "co.oursPosting": "%1 · %2",
  "co.whyOurs": "Warum wir sie für Sie verfolgen",
  "co.forYou": "%1 passend",
  "co.noneForYou": "keine passenden",
  "co.recOffer": "Angebot",
  "co.recInterviewing": "im Gespräch",
  "co.recInvited": "eingeladen",
  "co.recApplied": "%1 beworben",
  "co.recSilent": "%1 Tage still",
  "co.recRejected": "abgelehnt",
  "co.recQueued": "%1 zum Bewerben",
  "co.recSaved": "%1 gemerkt",
  "co.declinedShort": "Sie haben abgelehnt",
  "co.declinedOn": "Am %1 haben Sie abgelehnt.",
  "co.unreachableShort": "Ich kann die Stellen nicht lesen",
  "co.unreachableOn": "Die Karriereseite läuft auf %1, das ich nicht lesen kann.",
  "co.tierAccount": "hat jemanden mit Visumsbedarf tatsächlich eingeladen oder eingestellt",
  "co.tierPosting": "in einer Anzeige genannt",
  "co.tierResearch": "aus öffentlichen Quellen erschlossen",
  "co.tierUser": "von Ihnen gesagt",
  "co.hqHere": "Büro %1 (Sitz)",
  "co.restNote": "%1 weitere, nicht auf dieser Karte",
  "co.roundNo": "Runde %1",
  "co.search": "Firma, Branche, Stadt…",
  "co.searchIgnores": "Die Suche sieht alle Firmen: Verlauf und Verfolgung schränken sie nicht ein.",
  "co.rSaved": "Gemerkt",
  "co.rApplied": "Beworben",
  "co.rInterviewed": "Gesprochen",
  "co.rOffer": "Angebot",
  "co.matchGroup": "Passung",
  "co.matchHigh": "hohe Passung offen",
  "co.matchMid": "mittlere Passung offen",
  "co.placeGroup": "Ort",
  "co.industryGroup": "Branche",
  "co.sizeStageGroup": "Größe · Phase",
  "co.originGroup": "Wie sie hierher kam",
  "co.trackGroup": "Verfolgung",
  "co.trackCounts": "Über alle Firmen gezählt, unabhängig von Ihrem Verlauf. „Aussortiert“ ist standardmäßig nicht angehakt.",
  "co.sortRelation": "Nach Beziehung",
  "co.sortOpenings": "Passende Stellen",
  "co.sortName": "Name",
  "co.sortResearched": "Zuletzt recherchiert",
  "co.clearAll": "Alle Filter löschen",
  "co.emptyList": "Keine Firma passt.",
  "co.listTotal": "%1 companies",
  "co.emptyCard": "Wählen Sie eine Firma, hier steht ihre Karte.",
  "rel.similar": "ähnlich",
  "rel.upstream": "vorgelagert",
  "rel.downstream": "nachgelagert",
  "rel.rival": "Wettbewerber",
  "rel.same_group": "gleiche Gruppe",
  "covisa.yes": "Ja",
  "covisa.likely": "Wahrscheinlich",
  "covisa.unknown": "Unbekannt",
  "covisa.no": "Nein",

  // jobs page (block 4a)
  "jobs.search": "Firma, Rolle, Skill, Stadt…",
  "jobs.filters": "Filter",
  "jobs.status": "Status",
  "jobs.pending": "Zu sichten",
  "jobs.active": "In Arbeit",
  "jobs.excluded": "Übersprungen",
  "jobs.rejected": "Abgelehnt",
  "jobs.match": "Unter „Zu sichten“",
  "jobs.lv.high": "Hoch",
  "jobs.lv.mid": "Mittel",
  "jobs.lv.low": "Niedrig",
  "jobs.lv.unrated": "Nicht bewertet",
  "jobs.unratedTip": "Anzeigen ohne Einstufung: von deinen harten Kriterien vor der Einschätzung beiseitegelegt (die Gründe stehen unten unter „%1“) oder noch nicht eingeschätzt. Antippen, und sie erscheinen in der Liste.",
  "jobs.gone": "Entfernt",
  "jobs.goneTip": "Anzeigen, die der Arbeitgeber entfernt hat und die du nie beantwortet hast, stehen nicht unter „Zu sichten“. Anhaken, und sie sind wieder in der Liste. Gemerkte oder beworbene Anzeigen werden nie ausgeblendet, nur markiert.",
  "jobs.time": "Zeit",
  "jobs.fetched": "Abgeholt",
  "jobs.posted": "Veröffentlicht",
  "jobs.today": "Heute",
  "jobs.week": "Diese Woche",
  "jobs.month": "Dieser Monat",
  "jobs.custom": "Eigener Zeitraum",
  "jobs.from": "Von",
  "jobs.to": "Bis",
  "jobs.go": "Anwenden",
  "jobs.place": "Ort",
  "jobs.placeInput": "Stadt oder Land",
  "jobs.fromProfile": "Aus deinem Profil",
  "jobs.onsiteQ": "Büro",
  "jobs.moveQ": "Umzug",
  "jobs.hard": "Harte Kriterien",
  "jobs.visaGroup": "Visum",
  "jobs.langGroup": "Arbeitssprache",
  "jobs.payGroup": "Gehaltsuntergrenze",
  "jobs.yours": "Deine Angabe: %1",
  "jobs.roles": "Rollen",
  "jobs.rolesSearch": "Titel suchen",
  "jobs.companyGroup": "Firma",
  "jobs.setAside": "Vorab aussortiert (nicht bewertet)",
  "jobs.setAsideNote": "Anzeigen, die deine harten Kriterien schon vor der Einschätzung beiseitegelegt haben — nicht die, die du selbst ausgeschlossen hast.",
  "jobs.companyInput": "Firmenname",
  "jobs.boards": "Quellen",
  "jobs.mineGroup": "Meine",
  "jobs.pasted": "Von mir eingebracht",
  "jobs.relevelled": "Stufe von mir geändert",
  "jobs.tailored": "Lebenslauf angepasst",
  "jobs.closingWeek": "Frist diese Woche",
  "jobs.closed": "Entfernt",
  "jobs.deadline": "Frist",
  "jobs.sort": "Sortierung",
  "sort.priority": "Nach Priorität",
  "sort.match": "Beste Passung",
  "sort.posted": "Veröffentlicht",
  "sort.seen": "Abgeholt",
  "sort.closing": "Frist",
  "sort.company": "Nach Firma",
  "jobs.clear": "Alle abwählen",
  "pager.per": "%1 / page",
  "pager.perBox": "Rows per page",
  "pager.at": "Page %1 of %2",
  "pager.jumpBox": "Go to page",
  "pager.jumpHint": "Page",
  "pager.prev": "Previous page",
  "pager.next": "Next page",
  "pager.page": "Page %1",
  "jobs.new": "neu",
  "jobs.brought": "von dir eingebracht",
  "jobs.closedTag": "entfernt",
  "jobs.emptyActive": "Noch nichts gemerkt oder abgeschickt.",
  "jobs.emptyPending": "Hier gibt es gerade keine Stellen zum Prüfen.",
  "jobs.emptyHeldBack": "Links unter „Zu sichten“ ausgeblendet: noch %1.",
  "jobs.emptyExcluded": "Noch nichts übersprungen.",
  "jobs.emptyRejected": "Noch keine Absage.",
  "jobs.emptySearch": "Nichts Gelesenes passt dazu.",
  "jobs.emptyCard": "Wähle links eine Zeile; die Karte erscheint hier.",
  "jobs.savedDays": "gemerkt seit %1 Tagen",
  "jobs.sentDays": "vor %1 Tagen abgeschickt",
  "jobs.noReply": "noch keine Antwort",
  "jobs.closesOn": "Frist %1",
  "jobs.roundAt": "Runde %1 · %2",
  "jobs.timeToConfirm": "Termin zu bestätigen",
  "jobs.passedLine": "übersprungen · %1 · %2",
  "jobs.rejectedLine": "abgelehnt · %1",
  "jobs.daysAgo": "vor %1 Tagen",
  "jobs.yesterday": "gestern",
  "jobs.more": "Mehr",
  "jobs.lowReason": "Niedrige Passung: %1",
  "jobs.unratedReason": "Nicht gelesen: %1",
  "render.pending": "Einige Stellen sind noch nicht übersetzt. Sie stehen vorerst im Original und wechseln von selbst.",
  "render.tooLong": "Ein Teil ist zu lang für die Übersetzung und steht im Original.",
  "render.refused": "Einige Stellen ließen sich nicht übersetzen und stehen im Original.",
  "render.mark": "Original",
  "render.why.pending": "Noch nicht übersetzt. Die Übersetzung erscheint von selbst.",
  "render.why.tooLong": "Zu lang für die Übersetzung.",
  "render.why.refused": "Ließ sich nicht übersetzen.",
  "step.resume": "Lebenslauf lesen",
  "step.resume_content": "Details jeder Station lesen",
  "step.preferences": "Arbeitswünsche verstehen",
  "step.story": "Profil ergänzen",
  "step.profile": "Positionierung zusammenfassen",
  "step.constraints_check": "Bedingungen prüfen",
  "step.select_sources": "Quellen wählen",
  "step.report": "Positionsbericht schreiben",
  "step.fetch": "Stellen abrufen",
  "step.seed": "Jobbörsen für eine neue Richtung finden",
  "step.seed_pairs": "Jobbörsen für eine neue Richtung vorab finden",
  "step.topup": "Eigene Quellen nachlesen",
  "step.companies": "Arbeitgeber ordnen",
  "step.dedupe": "Dubletten entfernen",
  "step.scope": "Nach Bedingungen filtern",
  "step.langs": "Sprachanforderungen prüfen",
  "step.feedback": "Aus Feedback lernen",
  "step.judge": "Beurteilen",
  "step.apply_links": "Bewerbungsseiten der Stellen finden",
  "step.pairs_left": "Stellen für die weiteren Richtungen finden und lesen",
  "step.translate_judgment": "Beurteilungen übersetzen",
  "step.specs": "Eckdaten auslesen",
  "step.facts": "Anforderungen und Orte der Stellen für den Filter auslesen",
  "step.sponsoring": "Visa-Angaben der Stellen auslesen",
  "step.reading": "Anforderungen der Stellen auslesen",
  "step.hand_off": "Heutige Suchen dieser Zeitzone einreihen",
  "step.translate_posting": "Anzeigen übersetzen",
  "step.research": "Arbeitgeber recherchieren",
  "step.translate_company": "Arbeitgeberprofile übersetzen",
  "step.retire": "Geschlossene Stellen entfernen",
  "step.reasons": "Gründe zusammenfassen",
  "step.report_due": "Prüfen, ob der Bericht neu fällig ist",
  "step.brief": "Morgennotiz schreiben",
  "step.forms": "Bewerbungsformulare lesen",
  "step.questionnaire": "Fragebogen",
  "step.find_similar": "Ähnliche Arbeitgeber finden",
  "step.add_board": "Stellenbörse hinzufügen",
  "step.mail_watch": "Auf Antworten achten",
  "step.linkedin_search": "Arbeitgeber auf LinkedIn finden",
  "step.linkedin_resolve": "Ihre Stellenbörsen finden",
  "step.linkedin_sites": "Websites von Firmen suchen, die per Name nicht gefunden wurden",
  "step.aggregator_sites": "Aggregator-Seiten für gesuchte Länder finden",
  "step.arbeitnow_boards": "Stellenbörsen hinter arbeitnow-Anzeigen finden",
  "step.cdx_boards": "Stellenbörsen im öffentlichen Webindex finden",
  "step.check_boards": "Prüfen, wo Stellenbörsen einstellen",
  "step.admit_boards": "Gefundene Stellenbörsen in den Markt aufnehmen",
  "step.recheck_postings": "Prüfen, ob Anzeigen ohne eigene Stellenbörse noch offen sind",
  "step.follow_for_them": "Arbeitgeber für Sie verfolgen",
  "step.deep": "Tiefenrecherche",
  "step.accounts": "Interviewberichte suchen",
  "step.skills": "Fähigkeiten",
  "step.strategy": "Strategie",
  "step.backup": "Sichern",
  "step.retire_runs": "Alte Läufe entfernen",
  "step.archive_spend": "Modellkosten archivieren",
  "step.fx_rates": "Wechselkurse aktualisieren",
  "step.retire_visits": "Alte Besuche entfernen",
  "step.retire_auth": "Alte Anmeldedaten entfernen",
  "step.trial_notices": "Testphasen-Hinweise",
  "step.unlikely_check": "Stichprobe der unpassenden Stufe prüfen",
  "step.judge_all": "Den Rest genau lesen",
  "step.take": "Eingefügten Link lesen",
  "step.render": "Übersetzen",
  "jobs.back": "← Stellen",
  "jobs.deepTitle": "Einschätzung",
  "jobs.endedNoReason": "kein Grund angegeben",
  "shelf.target_country": "nicht in deinem Zielland",
  "shelf.target_city": "nicht in deiner Zielstadt",
  "shelf.radius": "außerhalb deines Radius",
  "shelf.needs_permit": "Rüstungs- / Sicherheitsarbeitgeber",
  "shelf.work_lang": "verlangt die Landessprache",
  "shelf.direction": "nicht deine Richtung",
  "shelf.salary_floor": "unter deiner Gehaltsuntergrenze",
  "shelf.remote": "Remote-Regel passt nicht",
  "shelf.start_by": "Starttermin passt nicht",
  "shelf.other": "anderes hartes Kriterium",
  "shelf.defence": "Verteidigungs- oder Geheimhaltungsarbeit",
  "shelf.declined": "Firma, die Sie abgelehnt haben",
  "shelf.window": "außerhalb des Zeitfensters deiner Region",
  "shelf.changed": "der Arbeitgeber hat sie an einen Ort verlegt, an dem du nicht suchst",
  "rejected.noTitle": "das Board hat sie ohne Titel gelistet",
  "rejected.noDescription": "das Board hat sie mit kaum oder gar keinem Text gelistet",
  "jobs.visaRecord": "Visumbilanz: %1 · aus %2 Anzeigen",
  // 岗位 · 今天 (block 4a, PR2)
  "jobs.allToday": "Alle Empfehlungen von heute →",
  "jobs.funnelThisWeek": "Diese Woche",
  "jobs.funnelLastWeek": "Letzte Woche",
  "jobs.funnelHow": "Kalenderwochen in deiner Zeitzone, ab Montag, Stand jetzt. Sehenswert: Stellen, die in dieser Woche eingegangen sind und als sehenswert beurteilt wurden – hohe, mittlere und niedrige Passung; im Stapel liegen nur die hohen Treffer von heute. Beantwortet: Stellen, deren letzte Statusänderung in diese Woche fällt, auch aus einer Benachrichtigung.",
  "jobs.funnelWorth": "sehenswert",
  "jobs.funnelAnswered": "beantwortet",
  "jobs.funnelMotion": "In Bewegung",
  "jobs.funnelCold": "Noch nichts zu berichten. Sobald die erste Suche abgeschlossen ist und du dir Stellen merkst und dich bewirbst, füllt sich das hier.",
  "jobs.funnelSaved": "Gemerkt",
  "jobs.funnelApplied": "Beworben",
  "jobs.funnelInterview": "Gespräch",
  "jobs.funnelOffer": "Angebot",
  "jobs.paste.title": "Eine einwerfen",
  "jobs.paste.placeholder": "Link zur Stelle",
  "jobs.paste.look": "Nachsehen",
  "jobs.paste.hint": "Schon da / gefiltert / jetzt aufgenommen.",
  "jobs.paste.have": "Schon da →",
  "jobs.paste.added": "Nie gesehen; jetzt aufgenommen. Wird in wenigen Minuten gelesen.",
  "jobs.paste.bad": "Das sieht nicht nach einem Link aus.",
  "jobs.paste.failed": "Das ging nicht rein.",
  "jobs.paste.recent": "Zuletzt eingeworfen",
  "jobs.paste.state.new": "wartet aufs Lesen",
  "jobs.paste.state.known": "schon vorhanden",
  "jobs.paste.state.added": "in der Liste",
  "jobs.paste.state.found": "Board gefunden",
  "jobs.paste.state.unresolved": "kein lesbares Board",
  "jobs.paste.state.failed": "Seite nicht lesbar",
  "jobs.paste.state.declined": "du hast abgelehnt",
  "shelf.judge": "nicht durch die Einschätzung",
  // the extension's panel (BLUEPRINT §6); %1 is the count or the name
  "ext.shown": "Die habe ich dir gezeigt — sie steht in der Liste.",
  "ext.judged": "Gelesen und als nicht deine Zeit wert eingestuft.",
  "ext.filtered": "Gesehen, aber schon vor der Einschätzung aussortiert.",
  "ext.shelved": "Die habe ich, aber nach deinem aktuellen Rahmen zurückgestellt.",
  "ext.unread": "Die habe ich — sie war nur noch nicht dran.",
  "ext.unseen": "Die habe ich nie gesehen. Das ist eine Lücke bei mir.",
  "ext.employerLede": "Das ist eine Firmenseite. Soll ich ihre Stellen beobachten?",
  "ext.find": "Diesen Arbeitgeber suchen",
  "ext.findNamed": "Das eigene Stellenboard von %1 suchen",
  "ext.keeping": "Keeping it…",
  "ext.asking": "Asking the server…",
  "ext.timeout": "The server never answered.",
  "ext.learned": "Kept %1 of your answers — the next form will not ask.",
  "ext.ask": "Ask something…",
  "ext.send": "Send",
  "ext.thinking": "Thinking…",
  "ext.thought": "How it got there",
  "ext.chatHere": "Ask",
  "ext.tailor": "Tailor my CV to this job",
  "ext.tailoring": "Getting it ready…",
  "ext.tailorOpened": "The rewrite lives in the portal — opened in a new tab.",
  "ext.tailorBlocked": "The rewrite lives in the portal — the browser would not let me open a tab.",
  "ext.tailorOpen": "Open the rewrite →",
  "ext.tailorKept": "This job is saved to your list.",
  "ext.tailorNotPosting": "No requirements can be read off this page, so there is nothing to tailor a CV to.",
  "ext.tailorNoCv": "Your CV has to be read once more before it can be rewritten line by line.",
  "ext.tailorToMe": "See it under “My profile” →",
  "ext.tailorFail": "The rewrite could not be started.",
  "ext.keptNew": "Kept. The portal will have a verdict within a minute — nothing to wait for here.",
  "ext.undo": "Undo",
  "ext.keptSame": "I already had this one — on %1's own board. Recorded against it.",
  "ext.keptFail": "Not kept — I could not read a job off this page.",
  "ext.boardOnly": "This is a job board page and I cannot tell who is hiring from it.\nOpen the employer's own site and click the icon there.",
  "ext.save": "Save",
  "ext.pass": "Not for me",
  "ext.saved": "Saved",
  "ext.passed": "Not for me",
  "ext.queued": "In your apply list",
  "ext.queueUp": "Queue to apply",
  "ext.markApplied": "I applied",
  "ext.appliedDone": "Applied",
  "ext.interviewRequested": "Interview invited",
  "ext.interviewing": "Interviewing",
  "ext.offer": "Offer",
  "ext.rejected": "Rejected",
  "ext.http409": "This one is already past applying — change it on the jobs site.",
  "ext.http402": "Die Probewoche ist vorbei — im Portal geht es weiter.",
  "ext.why": "Why this one",
  "ext.pause": "What gives me pause",
  "ext.noToken": "No key set — click the extension icon.",
  "ext.offline": "Cannot reach the server.",
  "ext.failed": "That did not go through. Try again?",
  "ext.badToken": "Dieser Schlüssel gilt nicht mehr — erstelle im Portal (Mein Profil → Einstellungen) einen neuen und füge ihn in den Einstellungen der Erweiterung ein.",
  "ext.openSettings": "Einstellungen der Erweiterung öffnen",
  "ext.notJson": "The server sent a page, not data — probably needs a login.",
  "ext.dock": "Dock as a side panel (bigger)",
  "ext.undock": "Back to a small panel",
  "ext.formHere": "There is a form here: %1 fields",
  "ext.known": "%1 I know",
  "ext.needYou": "%1 need you",
  "ext.yoursAlone": "%1 are yours alone (declarations, self-description)",
  "ext.menus": "%1 are dropdowns — one tap each",
  "ext.doFill": "Fill in what I know",
  "ext.answer": "Answer those %1",
  "ext.keep": "Keep these",
  "ext.back": "Back",
  "ext.retry": "Try again",
  "ext.retrying": "Trying…",
  "ext.left": "%1 to go",
  "ext.skip": "Skip",
  "ext.filled": "Filled %1.",
  "ext.refused": "%1 left empty — the options did not match.",
  "ext.askLede": "Answer once and no later form asks again.",
  "ext.yourWords": "%1 you have to write yourself",
  "ext.confirmName": "Bestätige deinen Namen für Bewerbungen unter Mein Profil → Einstellungen → Browser-Erweiterung",
  "ext.confirmHome": "Bestätige deinen Wohnort für Bewerbungen unter Mein Profil → Einstellungen → Browser-Erweiterung",
  "ext.confirmPhone": "Bestätige deine Telefonnummer für Bewerbungen unter Mein Profil → Einstellungen → Browser-Erweiterung",
  "ext.confirmSalary": "Gehaltsvorstellung leer gelassen: keine hinterlegt (dein Mindestgehalt wird dafür nie verwendet) – trage unter Mein Profil → Jobsucheinstellungen ein Zielgehalt ein, oder fülle es im Formular aus, dann wird es gemerkt",
  "ext.confirmSalaryCurrency": "Gehaltsvorstellung leer gelassen: Das Formular fragt in einer anderen Währung als dein Zielgehalt, und es wird nicht umgerechnet – fülle es im Formular aus, dann wird es gemerkt",
  "ext.assistTitle": "Fill just this one",
  "ext.singleFilled": "Filled.",
  "ext.singleUnknown": "I do not know this one yet — yours to fill.",
  "ext.singleFail": "Could not fill it.",
  "ext.improve": "Draft it with AI",
  "ext.draftLede": "Work this one out with AI, then press Insert.",
  "ext.draftAsk": "Say the points, or how to change it…",
  "ext.insert": "Insert",
  "ext.draftEmpty": "The draft is empty — talk it out with AI first.",
  "ext.looking": "Ich suche ihr Stellenboard — das dauert meist zehn bis zwanzig Sekunden…",
  "ext.finding": "Ich suche noch nach ihrem Stellenboard. Das Ergebnis steht danach im Portal unter Firmen.",
  "ext.foundFollowing": "%1 wird verfolgt: Die Stellen kommen in Ihre tägliche Suche.",
  "ext.foundDeclined": "Du hast %1 schon abgelehnt. Ändern kannst du das im Portal.",
  "ext.foundUnread": "Die Karriereseite von %1 läuft auf %2, das wir noch nicht lesen können. Sie steht im Portal unter Firmen.",
  "ext.foundNone": "Kein Stellenboard von %1, das wir lesen können. Sie steht im Portal unter Firmen.",
  "ext.foundNothing": "Kein Stellenboard dieses Arbeitgebers, das wir lesen können.",
  "ext.foundFailed": "Diese Seite ließ sich nicht lesen, das Stellenboard wurde nicht gefunden.",
  "ext.findOpen": "Im Portal ansehen →",
  "ext.employerSite": "Das ist die Website von %1.",
  "ext.employerUnread": "Das Stellenboard von %1 können wir nicht lesen — behalte hier die Stellen, die du willst, sie kommen auf die Karte.",
  "ext.autoOpen": "Ab jetzt auf dieser Website von selbst öffnen",
  "ext.autoOpenAsked": "Bestätige es auf der eben geöffneten Einstellungsseite.",
  "ext.viaCompanyPage": "Diese Seite nennt die Website von %1 nicht. Öffne ihre LinkedIn-Firmenseite und klicke dort auf das Symbol — dort kann ich sie lesen.",
  "ext.companyPageOpen": "Firmenseite öffnen →",
  "ext.noSite": "Die LinkedIn-Seite von %1 nennt keine eigene Website, daher finde ich ihr Stellenboard nicht.",
  "ext.noSitePage": "Diese Seite nennt die Website von %1 nicht, daher finde ich ihr Stellenboard nicht.",
  // ---- die Gesprächsseite (Block 4c): Kalender, die zwei Listen, die Leseansicht
  "iv.prevMonth": "Voriger Monat",
  "iv.nextMonth": "Nächster Monat",
  "iv.prevWeek": "Vorige Woche",
  "iv.nextWeek": "Nächste Woche",
  "iv.today": "Heute",
  "iv.week": "Woche",
  "iv.month": "Monat",
  "iv.markInterview": "Gespräch",
  "iv.markUnconfirmed": "Zu bestätigen",
  "iv.markDeadline": "Abgabe fällig",
  "iv.kind.screen": "Erstgespräch",
  "iv.kind.technical": "Fachgespräch",
  "iv.kind.system": "Systemdesign",
  "iv.kind.behavioural": "Verhaltensfragen",
  "iv.kind.take_home": "Aufgabe für zu Hause",
  "iv.kind.written": "Schriftlicher Test",
  "iv.kind.onsite": "Vor Ort",
  "iv.kind.final": "Abschlussgespräch",
  "iv.kind.other": "Anderes",
  "iv.format.video": "Video",
  "iv.format.phone": "Telefon",
  "iv.format.onsite": "Vor Ort",
  "iv.format.async": "Asynchron",
  "iv.roundNo": "Runde %1",
  "iv.due": "fällig",
  "iv.unscheduled": "Noch kein Termin",
  "iv.theirTime": "ihre Zeit %1",
  "iv.toConfirm": "Termin bestätigen",
  "iv.noTimeYet": "Kein Termin vereinbart",
  "iv.cancelled": "Abgesagt",
  "iv.roundDone": "Erledigt",
  "iv.timeNo": "Der Termin passt nicht",
  "iv.upcoming": "Bevorstehend",
  "iv.allDays": "Alle Tage",
  "iv.addRound": "Eintragen",
  "iv.noneAhead": "Nichts geplant.",
  "iv.ended": "Beendet",
  "iv.noneEnded": "Noch nichts beendet.",
  "iv.nothing": "Noch keine Gespräche. Markiere eine Stelle als „zum Gespräch eingeladen“, dann erscheint sie hier.",
  "iv.back": "← Gespräche",
  "iv.joinLink": "Meeting-Link ↗",
  "iv.packet.deep": "Recherche",
  "iv.packet.accounts": "Erfahrungsberichte",
  "iv.packet.skills": "Fähigkeiten",
  "iv.packet.strategy": "Strategie",
  "iv.packetWhat.deep": "was diese Firma und diese Stelle tun",
  "iv.packetWhat.accounts": "was andere hier gefragt wurden",
  "iv.packetWhat.skills": "was geprüft wird und wie viel davon du hast",
  "iv.packetWhat.strategy": "was zu betonen ist, wo nachgehakt wird",
  "iv.reason.none_found": "Zu dieser Firma wurden keine Erfahrungsberichte gefunden.",
  "iv.reason.namesake": "Es wurden Erfahrungsberichte gefunden, aber sie betreffen womöglich eine gleichnamige andere Firma und werden nicht verwendet.",
  "iv.reason.no_skills_named": "Für diese Stelle wurde noch keine Liste der Fähigkeiten gelesen, es gibt nichts abzugleichen.",
  "iv.reason.no_web": "Diesmal wurde nicht im Web gesucht.",
  "iv.reason.search_unavailable": "Der Suchdienst hat einen Fehler gemeldet, die Suche ist nicht durchgegangen.",
  "iv.reason.model_unavailable": "Der Schreibdienst hat einen Fehler gemeldet, das ist nicht vollständig.",
  "iv.reason.budget": "Das Budget dieser Vorbereitung war aufgebraucht, bevor dieser Teil fertig war.",
  "iv.reason.rejected": "Ein Teil des Geschriebenen hat die Prüfung nicht bestanden und wurde nicht gespeichert.",
  "iv.reason.untranslated": "Die Übersetzung in deine Sprache hat nicht geklappt.",
  "iv.reason.needs_cv": "Die Fähigkeiten aus deinem Lebenslauf sind noch nicht eingelesen, es gibt nichts abzugleichen.",
  "iv.reason.needs_judgment": "Diese Stelle ist noch nicht bewertet, eine Strategie gibt es noch nicht.",
  "iv.reason.needs_company": "Zu dieser Firma gibt es noch keine Recherche, die Stelle konnte nicht untersucht werden.",
  "iv.reason.failed": "Dieser Teil ist nicht fertig geworden.",
  "iv.noneFoundGuess": "Zu dieser Firma wurden keine Erfahrungsberichte gefunden; das Folgende ist aus der Stelle abgeleitet.",
  "iv.namesakeGuess": "Die gefundenen Erfahrungsberichte betreffen womöglich eine gleichnamige andere Firma; das Folgende ist aus der Stelle abgeleitet.",
  "iv.notStarted": "Die Vorbereitung hat nicht begonnen.",
  "iv.queued": "In der Warteschlange; die vier Teile erscheinen hier, sobald sie gelaufen sind.",
  "iv.running": "Wird vorbereitet; schau in ein paar Minuten wieder vorbei.",
  "iv.ranEmpty": "Die Vorbereitung lief, keines der vier ist herausgekommen.",
  "iv.strategy.they_value": "Worauf sie Wert legen",
  "iv.strategy.emphasise": "Betonen",
  "iv.strategy.will_be_questioned": "Wird hinterfragt",
  "iv.strategy.ask_them": "Sie fragen",
  "iv.strategy.sponsorship": "Arbeitserlaubnis ansprechen",
  "iv.skillCount": "%1 · Kern %2 / Ergänzend %3",
  "iv.by.cv": "aus dem Lebenslauf",
  "iv.by.model": "eingeschätzt",
  "iv.unverified": "unbestätigt",
  "iv.source.firsthand": "aus erster Hand",
  "iv.source.employer": "Arbeitgeber",
  "iv.source.aggregator": "Sammlung",
  "iv.source.other": "anderes",
  "iv.sourceLegend": "Aus erster Hand = von jemandem geschrieben, der dort im Gespräch war; Arbeitgeber = die eigene Darstellung der Firma; Sammlung = zusammengetragene Liste; vermutet = meine Annahme aus der Anzeige.",
  "iv.snippetOnly": "nur Suchausschnitt",
  "iv.inferredWhole": "die ganze Mappe ist vermutet",
  "iv.inferred": "Wahrscheinliche Themen",
  "iv.inferredCaveat": "Aus der Anzeige und verwandtem Material vermutet, kein Bericht eines echten Gesprächs.",
  "iv.deep": "Tiefenrecherche",
  "iv.team": "Team",
  "iv.problem": "Woran sie arbeiten",
  "iv.stack": "Technik",
  "iv.business": "Womit sie Geld verdienen",
  "iv.risks": "Risiken",
  "iv.process": "Bewerbungsablauf",
  "iv.angles": "Gesprächsthemen",
  "iv.news": "Aktuelle Entwicklungen",
  "iv.viewResearch": "Recherche ansehen",
  "iv.hideResearch": "Recherche schließen",
  "iv.sourceDetails": "Suche und Quellen:",
  "iv.roleSources": "Stellenquellen:",
  "iv.companySources": "Unternehmensquellen:",
  "iv.notePrompt": "Was gefragt wurde / wie es lief / was folgt",
  "iv.notePlaceholder": "Eine Zeile nach der Runde…",
  "iv.share": "Diese Notizen anonym beitragen: deine Identität wird entfernt, Fragen und Ablauf bleiben.",
  "iv.saveNote": "Speichern",
  "iv.markDone": "Erledigt",
  "iv.saveFailed": "Nicht gespeichert: %1",
  "iv.addRoundN": "＋ Runde %1 eintragen",
  "iv.fieldKind": "Art",
  "iv.fieldWhen": "Wann",
  "iv.fieldMinutes": "Minuten",
  "iv.fieldFormat": "Format",
  "iv.fieldLink": "Meeting-Link",
  "iv.fieldLang": "Sprache",
  "iv.fieldWho": "Gesprächspartner",
  "iv.saveRound": "Eintragen",
  "iv.cancel": "Abbrechen",
  "round.title": "Einladung erhalten: diese Runde eintragen",
  "round.titleNext": "Gespräche laufen: diese Runde eintragen",
  "round.titleTime": "Termin nachtragen",
  "round.titleAdd": "Gesprächsrunde eintragen",
  "round.later": "Später eintragen",
  "round.laterNote": "„Später eintragen“ ändert den Status trotzdem; den Termin kannst du danach auf der Karte nachtragen.",
  "round.needWhen": "zuerst den Termin eintragen",
  "card.noTime": "Noch kein Termin eingetragen – im Kalender steht das Gespräch noch nicht.",
  "card.addTime": "Termin eintragen",

  "strength.hard": "hart",
  "strength.strong": "stark",
  "strength.mild": "leicht",
  "profile.sec.positions": "Berufserfahrung",
  "profile.sec.skills": "Kenntnisse",
  "profile.sec.about": "Profil",
  "profile.sec.education": "Ausbildung",
  "profile.sec.publication": "Veröffentlichungen",
  "profile.sec.certification": "Zertifikate",
  "profile.sec.award": "Auszeichnungen",
  "profile.sec.project": "Projekte",
  "profile.sec.other": "Sonstiges",
  // ---- 我的资料（块 4d）：关于我 / 规则 / 设置 与定位报告
  "me.tab.about": "Über Sie",
  "me.tab.rules": "Jobsucheinstellungen",
  "me.tab.settings": "Einstellungen",
  "me.ask.one": "Eine Sache zum Bestätigen",
  "me.ask.rule": "Das würde ändern, was Sie sehen — Ihre Entscheidung",
  "me.ask.shelve": "Diese Art beiseitelegen?",
  "me.ask.report": "Ihr Positionsbericht ist fertig",
  "me.ask.generic": "Etwas wartet auf Ihre Antwort.",
  "me.ask.placeholder": "Antworten Sie in eigenen Worten…",
  "me.ask.send": "Antworten",
  "me.name.title": "Dein Name in Bewerbungsformularen",
  "me.name.full": "Vollständiger Name",
  "me.name.first": "Vorname",
  "me.name.last": "Nachname",
  "me.name.unconfirmed": "Noch nicht bestätigt. Bis zur Bestätigung lässt die Erweiterung die Namensfelder für dich frei.",
  "me.name.confirmed": "Bestätigt – Bewerbungsformulare werden mit diesem Namen ausgefüllt.",
  "me.name.save": "Bestätigen",
  "me.cv.title": "Ihr Lebenslauf",
  "me.cv.upload": "Hochladen",
  "me.cv.replace": "Ersetzen",
  "me.cv.sending": "Wird hochgeladen…",
  "me.cv.tooBig": "Über 10MB",
  "me.cv.same": "Das ist die Datei, die schon vorliegt — nichts hat sich geändert.",
  "me.cv.none": "Noch kein Lebenslauf. Laden Sie einen hoch, und ich frage nichts, was ich darin lesen kann.",
  "me.cv.meta": "%1 KB · hochgeladen %2 · %3 Stationen · %4 Abschlüsse · %5 Fähigkeiten",
  "me.cv.inProgress": "laufend",
  "me.cv.unread": "Noch nicht gelesen — es ist eingereiht und wird in wenigen Minuten gelesen.",
  "me.cv.detailsPending": "Stationen und Abschlüsse sind gelesen; was Sie in jeder Station getan haben und die übrigen Kenntnisse werden noch gelesen.",
  "me.cv.detailsRefused": "Stationen und Abschlüsse sind gelesen, aber was Sie in jeder Station getan haben und die übrigen Kenntnisse ließen sich nicht lesen — ein neuer Lebenslauf wird neu gelesen.",
  "me.cv.failed": "Diese Datei ließ sich nicht lesen: %1. Speichern Sie eine neue Kopie und laden Sie diese hoch, oder laden Sie ein PDF hoch.",
  "me.cv.why.no_text": "sie enthält keinen lesbaren Text — vermutlich ein Scan oder ein Bild",
  "me.cv.why.locked": "sie ist passwortgeschützt oder ein altes .doc",
  "me.cv.why.other_type": "sie ist weder ein PDF noch ein Word-Dokument",
  "me.cv.why.damaged": "die Datei ist beschädigt",
  "me.cv.why.unreadable": "beim Lesen ging etwas schief",
  "me.cv.refused": "Diesen Lebenslauf konnte ich nicht lesen: %1, daher wurde nichts davon übernommen. Laden Sie dieselbe Datei erneut hoch, dann lese ich sie noch einmal — oder versuchen Sie eine Word-Fassung (.docx).",
  "me.cv.why.refused": "was ich daraus gelesen habe, hat meine Prüfung nicht bestanden",
  "me.cv.download": "Original herunterladen",
  "me.cv.earlier": "Frühere Lebensläufe",
  "me.cv.earlierOn": "hochgeladen %1",
  "me.cv.earlierMore": "%1 weitere",
  "me.cv.fold": "Was ich daraus gelesen habe",
  "me.cv.wrong": "Falsch gelesen? Ersetzen Sie den Lebenslauf oder sagen Sie es mir im Gespräch; ich halte es als neue Fassung Ihres Profils fest.",
  "me.doc.profile": "Ihr Profil · Fassung %1",
  "me.doc.at": "geändert %1",
  "me.doc.never": "noch nicht geschrieben",
  "me.doc.emptyProfile": "Noch kein Profil. Laden Sie einen Lebenslauf hoch oder erzählen Sie mir im Gespräch, was Sie suchen.",
  "me.doc.ownOnly": "In diesem Feld steht der Teil Ihres Profils, der aus Ihren Gesprächen mit dem Agenten entstanden ist. Was für Sie geschrieben wird, bleibt, wie es ist, und kann hier nicht geändert werden:",
  "me.doc.overviewNote": "„Positionierung und Hintergrund“ entsteht aus Lebenslauf, Einstellungen und Antworten und wird beim Hochladen eines neuen Lebenslaufs neu geschrieben.",
  "me.doc.notesNote": "„Ort und Arbeitsmodell“ fasst Ihre Jobsucheinstellungen zusammen und folgt ihnen.",
  "profile.block.profile_overview": "Positionierung und Hintergrund",
  "profile.block.job_search_notes": "Ort und Arbeitsmodell",
  "profile.block.learned": "Aus Ihrem Feedback gelernt",
  "me.doc.notesLink": "In den Einstellungen ändern",
  "me.doc.edit": "Bearbeiten",
  "me.doc.save": "Speichern",
  "me.doc.conflict": "Wenn Ihr Teil inzwischen an anderer Stelle geändert wurde — etwa im Gespräch notiert —, wird das Speichern abgelehnt; neu laden und erneut bearbeiten. Änderungen an den vom System geschriebenen Teilen verhindern es nicht.",
  "me.src.web": "von Ihnen bearbeitet",
  "me.src.chat": "aus dem Gespräch",
  "me.src.resume": "aus dem Lebenslauf",
  "me.src.criterion": "eine bestätigte Regel",
  "me.src.constraint": "mit einer Bedingung geändert",
  "me.src.question": "eine beantwortete Frage",
  "me.src.feedback": "aus Ihrem Feedback",
  "me.src.unknown": "keine Quelle vermerkt",
  "me.hc.permitNo": "nicht erforderlich",
  "me.hc.direction": "Zielrichtung",
  "me.hc.hint.salary_floor": "80k",
  "me.report.title": "Marktpositionsbericht",
  "me.report.locked": "Dafür brauche ich noch:",
  "me.report.need.resume": "einen Lebenslauf",
  "me.report.need.profile": "ein Profil",
  "me.report.need.market": "die Marktdaten dieses Monats",
  "me.report.need.questions": "%1 offene Fragen",
  "me.report.lockedHint": "Der Knopf leuchtet, wenn die Liste vollständig ist.",
  "me.report.ready": "Eingaben vollständig: Profil v%1 · Markt %2",
  "me.report.making": "Bericht wird geschrieben…",
  "me.report.retry": "Neu schreiben",
  "me.report.failedHint": "Dieser hier wurde nicht geschrieben. Der Grund steht oben; zum erneuten Versuch drücken.",
  "me.report.failed.money": "Das Budget war aufgebraucht. Erhöhen und erneut versuchen.",
  "me.report.failed.refused": "Was das Modell schrieb, fiel zweimal durch die Prüfung (ein Zitat passte nicht, oder die Form stimmte nicht). Ein zweiter Versuch klappt meist.",
  "me.report.failed.timeout": "Nach fünfzehn Minuten noch nicht fertig und abgebrochen. Erneut versuchen.",
  "me.report.failed.provider": "Das Modell lief auf einen Fehler; nichts wurde geschrieben. Erneut versuchen.",
  "me.report.failed.unknown": "Nicht fertig geworden und ohne Grund — vermutlich unterwegs abgebrochen. Erneut versuchen.",
  "me.report.writingHint": "Er steht in der Warteschlange. Diese Karte ändert sich von selbst, sobald er fertig ist.",
  "me.report.make": "Bericht erstellen",
  "me.report.again": "Neu erstellen",
  "me.report.open": "Bericht öffnen →",
  "me.report.back": "← Über Sie",
  "me.report.written": "geschrieben %1 · insgesamt %2",
  "me.report.same": "Nothing it was written from has moved since.",
  "me.report.moved": "Geändert: %1",
  "me.report.versions": "%1 frühere Berichte",
  "me.report.from": "Profil v%1 · %2",
  "me.report.head": "Marktpositionsbericht · %1",
  "me.report.empty": "Dieser Bericht hat keine Abschnitte.",
  "me.report.howTitle": "Woraus er entstand",
  "me.report.how": "Lebenslauf und Profil sind Fassungen: nur eine Änderung zählt. Der Markt zählt nach Woche und Größenordnung der Empfehlungen — eine neue Woche oder doppelt bzw. halb so viele; nach der ersten Suche wird der Bericht einmal neu geschrieben.",
  "me.report.market.searching": "vor Ende der ersten Suche",
  "me.report.market.week": "Woche vom %1",
  "me.report.input.resume": "Lebenslauf",
  "me.report.input.profile": "Profil",
  "me.report.input.market": "Markt",
  "me.report.stillAsking": "Es gibt noch offene Fragen; sie zu beantworten schärft den nächsten Bericht.",
  "me.report.s.summary": "In einem Satz",
  "me.report.s.strengths": "Ihre Stärken",
  "me.report.s.positioning": "Worauf zielen",
  "me.report.s.market": "Was der Markt verlangt",
  "me.report.s.gaps": "Ihre Lücken",
  "me.report.s.next_steps": "Diese Woche",
  "me.w.title": "Wie ich sortiere",
  "me.w.lede": "Ein Filterklick hebt den zugehörigen Faktor an (%1). Entscheidungen und Ihre Begründungen bewegen diese Gewichte nicht; sie werden weiter unten auf dieser Seite zu Regeln. Die übrigen nutzen den Standard oder das, was Sie unten einstellen.",
  "me.w.edit": "Anpassen",
  "me.w.save": "Speichern",
  "me.w.reset": "Zurück zum Standard",
  "me.w.saveHint": "Die Liste wird nach dem Speichern sofort nach den neuen Gewichten sortiert.",
  "me.w.f.stack": "Stack",
  "me.w.f.fit": "Passung",
  "me.w.f.where": "Von dir aus machbar",
  "me.w.f.reach": "Wie viele bewerben können",
  "me.w.f.age": "Wie neu",
  "me.w.f.chance": "Antwortchance",
  "me.w.f.level": "Stufe",
  "me.w.f.visa": "Visum",
  "me.w.f.stability": "Stabilität",
  "me.w.f.pay": "Gehalt",
  "me.w.why.default": "Standard",
  "me.w.why.attention": "%1× gefiltert",
  "me.w.why.own": "von Ihnen gesetzt",
  "me.w.why.stack": "Multiplikator, nicht einstellbar",
  "me.learned.title": "Kürzlich gelernt",
  "me.learned.where": "What you confirm becomes one of your rules, which the judge reads word for word.",
  "me.rules.n": "%1",
  "me.rules.none": "Noch nichts bestätigt.",
  "me.rules.title": "Regeln",
  "me.rules.lede": "Die geltenden Regeln; die Bewertung liest sie wörtlich. Eine zurückgezogene gilt ab dem nächsten Lauf nicht mehr; eine harte schließt Stellen aus.",
  "me.rules.add": "Regel hinzufügen",
  "me.rules.what": "Eine Regel, ein Satz",
  "me.rules.retire": "Zurückziehen",
  "me.rules.group.auto": "Rules in force without your confirmation",
  "me.rules.group.confirmed": "Rules you confirmed",
  "me.report.input.criteria": "rules",
  "me.doc.rules.count": "Rules in force: %1",
  "me.doc.rules.quoted": " (%1)",
  "me.doc.rules.item": "%1: “%2”",
  "me.doc.rules.sep": "; ",
  "me.doc.rules.more": "%1 more",
  "me.doc.rules.link": "Job search settings → Rules",
  "me.doc.learnedNote": "„Aus Ihrem Feedback gelernt“ ist, was der nächtliche Lauf aus Ihren Ablehnungsgründen, Kommentaren und Formularantworten gelernt hat.",
  "me.src.rules": "Regeln geändert",
  "me.doc.correctionHeading": "Korrektur zum Lebenslauf",
  "me.reasons.title": "Warum Sie ablehnen",
  "me.reasons.lede": "Nach Häufigkeit sortiert; die häufigsten stehen auf der Karte vorn.",
  "me.reasons.uses": "%1× verwendet",
  "me.reasons.teaser": "%1 reasons · most used: %2",
  "me.reasons.teaserNone": "%1 reasons, none used yet",
  "me.set.on": "an",
  "me.set.off": "aus",
  "me.set.turnOn": "Einschalten",
  "me.set.turnOff": "Ausschalten",
  "me.set.switchFailed": "Das hat nicht geklappt. Bitte versuch es noch einmal.",
  "wait.working": "Wird gespeichert…",
  "wait.failed": "Das hat nicht geklappt. Bitte versuch es noch einmal.",
  "me.set.ch.title": "Benachrichtigungen",
  "me.set.ch.lede": "Per E-Mail kommen die Morgenliste und Hinweise zur Testphase; Slack bringt außerdem Fragen, Berichte, Leads und die Interviewvorbereitung. Alles andere steht auf der Seite. Eine ausgeschaltete Adresse bekommt nichts mehr.",
  "me.set.ch.none": "Noch keine Adresse, unter der ich dich erreiche — es kann nichts verschickt werden.",
  "me.set.ch.kind.email": "E-Mail",
  "me.set.ch.kind.slack": "Slack",
  "me.set.ch.kind.whatsapp": "WhatsApp",
  "me.set.ch.kind.telegram": "Telegram",
  "me.set.ch.since": "hinzugefügt %1",
  "me.set.ch.quiet": "still %1–%2",
  "me.set.ch.events": "nur: %1",
  "me.set.ch.remove": "Verbindung trennen",
  "me.set.ch.removeTitle": "„%1“ trennen?",
  "me.set.ch.removeAsk": "Danach hören Pushes und Chat hier auf; um sie zurückzubekommen, verbinde es erneut.",
  "me.set.ch.removeAskPush": "Danach kommen hier keine Pushes mehr an; um sie zurückzubekommen, verbinde es erneut.",
  "me.set.ch.push": "Push",
  "me.set.ch.loginEmail": "Das ist deine Login-E-Mail und kann nicht getrennt werden — ändere die Adresse unter Konto, oder schalte den Schalter rechts aus, um keine Mails mehr zu bekommen.",
  "me.set.days.title": "Morgenbrief",
  "me.set.days.hint": "An den ausgewählten Morgen geht ein Brief hinaus; an diesen Tagen wird ein Stapel Urteile verschickt.",
  "me.set.days.none": "Kein Tag ausgewählt: es geht kein Morgenbrief hinaus.",
  "me.set.auto.title": "Was von allein läuft",
  "me.set.auto.lede": "Nur diese beiden Schalter werden überhaupt gelesen: jeder entscheidet, ob ein gesetzter Status von allein einen Lauf startet.",
  "me.set.auto.similar": "Nach „beworben“ nach Ähnlichem suchen",
  "me.set.auto.what.similar": "An: „beworben“ stellt Segment S4 in die Warteschlange — ähnliche Firmen und Stellen, und jeder angenommene Hinweis wird ein neues Board. Aus: es wird nur festgehalten, dass du dich beworben hast.",
  "me.set.auto.prep": "Nach „Interview angefragt“ Material vorbereiten",
  "me.set.auto.what.prep": "An: Wenn du eine Stelle als eingeladen markierst, werden vier Unterlagen vorbereitet — Recherche zu Firma und Stelle, Erfahrungsberichte, ein Abgleich der Fähigkeiten und eine Strategie. Aus: es wird nichts vorbereitet, und es gibt keine andere Stelle, das zu starten.",
  "me.set.auto.onlyTwo": "Mehr gibt es nicht. Postfach lesen, eine Uhrzeit für nachts, Ausfüllstufen, Massenbewerbung — nichts davon ist gebaut, also steht hier auch kein Schalter dafür.",
  "me.set.ext.title": "Browser-Erweiterung",
  "me.set.ext.identity": "Angaben für Bewerbungsformulare",
  "me.set.ext.identityHint": "Die Vorschläge stammen aus deinen vorhandenen Angaben. Bestätige Namen, Wohnort und Telefonnummer für Bewerbungen einzeln. Diese Auswahl gilt nur für das Ausfüllen durch die Erweiterung.",
  "me.set.ext.residence": "Wohnort",
  "me.set.ext.place": "Stadt, Land oder vollständiger Wohnort",
  "me.set.ext.phone": "Telefon",
  "me.set.ext.number": "Telefonnummer",
  "me.set.ext.confirmed": "Für Bewerbungsformulare bestätigt.",
  "me.set.ext.unconfirmed": "Noch nicht bestätigt; die Erweiterung lässt dieses Feld für dich frei.",
  "me.set.ext.noSource": "Keine Angabe vorhanden; gib einen Wert ein und bestätige ihn",
  "me.set.ext.source.said": "Aus deinen eigenen Angaben",
  "me.set.ext.source.resume": "Aus deinem aktuellen Lebenslauf",
  "me.set.ext.source.account": "Aus deinem Konto",
  "me.set.ext.source.verified": "Aus deiner bestätigten Telefonnummer",
  "me.set.ext.direct": "E-Mail-Adresse und Links werden ohne weitere Bestätigung aus deinen vorhandenen Angaben übernommen.",
  "me.set.ext.email": "E-Mail-Adresse",
  "me.set.ext.website": "Webseite",
  "me.set.ext.none": "Noch kein Schlüssel: die Erweiterung kann sich nicht verbinden.",
  "me.set.ext.mint": "Schlüssel erstellen",
  "me.set.ext.revoke": "Widerrufen",
  "me.set.ext.on": "Verbunden · dieser Schlüssel wurde %1 erstellt",
  "me.set.ext.replace": "Durch einen neuen Schlüssel ersetzen",
  "me.set.ext.one": "Ein Konto hat einen Schlüssel. Nutzt du die Erweiterung in mehreren Browsern oder auf mehreren Rechnern, füge beim Erstellen denselben Schlüssel überall ein; ersetzt du ihn, dann überall.",
  "me.key.title": "Dein Schlüssel für die Erweiterung",
  "me.key.titleReplace": "Schlüssel ersetzen?",
  "me.key.replaceBody": "Der jetzige Schlüssel gilt sofort nicht mehr, und jeder Browser mit der Erweiterung braucht den neuen.",
  "me.key.replaceYes": "Ersetzen",
  "me.key.cancel": "Abbrechen",
  "me.key.making": "Schlüssel wird erstellt…",
  "me.key.failed": "Der Schlüssel wurde nicht erstellt — versuch es noch einmal.",
  "me.key.again": "Noch einmal",
  "me.key.once": "Nur dieses eine Mal sichtbar — kopiere ihn jetzt. Sobald das hier zu ist, ist er nicht mehr zu sehen.",
  "me.key.copy": "Kopieren",
  "me.key.copied": "Kopiert",
  "me.key.copyByHand": "Er ist markiert — mit ⌘C / Strg+C kopieren.",
  "me.key.next": "In der Erweiterung eintragen: „Einstellungen der Erweiterung öffnen“ in ihrem Panel, oder Rechtsklick auf das Symbol → Optionen; einfügen und speichern.",
  "me.key.done": "Fertig",
  "me.set.ext.shownOnce": "Ein Schlüssel wird genau einmal angezeigt, beim Erstellen; gespeichert wird nur sein Hash, er lässt sich nicht wieder nachschlagen — wenn du ihn verlierst, ersetze ihn durch einen neuen.",
  "me.set.acct.title": "Konto",
  "me.set.acct.email": "Anmelde-E-Mail",
  "me.set.acct.noEmail": "keine hinterlegt",
  "me.set.acct.since": "dabei seit %1",
  "me.set.acct.lang": "Sprache für E-Mail und Push",
  "me.set.acct.langNote": "Nachrichten, die dir per E-Mail, Slack und WhatsApp geschickt werden, sind in dieser Sprache geschrieben; auch dein Profil, deine Regeln und dein Positionierungsbericht werden darin geführt.",
  "me.set.acct.tz": "Zeitzone",
  "me.set.acct.tzHint": "Europe/Berlin",
  "me.set.acct.tzNote": "Jedes Datum auf diesen Seiten und der Tag, den der Morgenbrief zählt, werden in dieser Zone gelesen.",
  "me.set.acct.save": "Speichern",
  "me.set.acct.delete": "Um Konto und Daten löschen zu lassen, schreiben Sie uns:",
  "me.set.acct.deleteSubject": "Konto löschen",
  "me.set.export.title": "Export",
  "me.set.export.short": "Download your personal data.",
  "me.set.export.what": "Eine ZIP-Datei: deine hochgeladenen Lebensläufe und die Dateien, die du in Gesprächen geschickt hast, unverändert, und ein Dokument mit dem Rest — Konto, Profil, Sucheinstellungen und Regeln, Gespräche, beantwortete Fragen, Entscheidungen zu Stellen und Interviews — dazu dasselbe maschinenlesbar als data.json. Stellen und Unternehmen, wie wir sie gesammelt haben, und die eigenen Aufzeichnungen des Dienstes sind nicht enthalten; schreib uns, wenn du sie möchtest.",
  "me.set.export.go": "Meine Daten exportieren",
  "mine.title": "Meine Daten bei Counting",
  "mine.toc": "Inhalt",
  "mine.sec.about": "Über diese Datei",
  "mine.sec.account": "Konto",
  "mine.sec.profile": "Profil",
  "mine.sec.resume": "Hochgeladene Lebensläufe",
  "mine.sec.search": "Sucheinstellungen und Regeln",
  "mine.sec.threads": "Gespräche mit dem Agenten",
  "mine.sec.questions": "Beantwortete Fragen",
  "mine.sec.jobs": "Entscheidungen zu Stellen",
  "mine.sec.interviews": "Interviews",
  "mine.about.intro": "Diese Datei enthält, was du Counting gegeben hast, und was dich selbst betrifft. Derselbe Inhalt liegt maschinenlesbar als data.json im selben ZIP.",
  "mine.about.files": "Außerdem im ZIP: resume/ enthält deine hochgeladenen Lebensläufe, attachments/ die Dateien, die du in Gesprächen geschickt hast.",
  "mine.about.at": "Exportiert",
  "mine.about.tz": "Zeiten in",
  "mine.about.left": "Nicht enthalten",
  "mine.left.jobs": "Stellen und Unternehmen, wie wir sie gesammelt oder aufbereitet haben, und wie wir sie bewertet haben",
  "mine.left.system": "Eigene Aufzeichnungen des Dienstes (Läufe, Verbrauch, Besuche usw.)",
  "mine.left.billing": "Zahlungsdaten",
  "mine.left.tailor": "Umgeschriebene Lebensläufe",
  "mine.about.ask": "Wenn du davon etwas möchtest, schreib an %1.",
  "mine.about.askAnyway": "Wenn du davon etwas möchtest, schreib uns.",
  "mine.about.lost": "Dateien, die nicht gelesen werden konnten und nicht im ZIP sind",
  "mine.file.missing": "die Datei fehlt",
  "mine.file.changed": "die Datei ist nicht die gespeicherte",
  "mine.file.gone": "nur der Eintrag ist übrig; die Datei wurde gelöscht",
  "mine.acct.email": "E-Mail",
  "mine.acct.phone": "Telefon",
  "mine.acct.lang": "Sprache",
  "mine.acct.tz": "Zeitzone",
  "mine.acct.since": "Registriert",
  "mine.profile.doc": "Über mich",
  "mine.profile.docAt": "Zuletzt geändert",
  "mine.profile.experience": "Berufserfahrung",
  "mine.profile.education": "Ausbildung",
  "mine.profile.skills": "Fähigkeiten",
  "mine.profile.items": "Sonstiges",
  "mine.exp.period": "Zeitraum",
  "mine.exp.location": "Ort",
  "mine.exp.summary": "Zusammenfassung",
  "mine.exp.claims": "Schwerpunkte",
  "mine.exp.stack": "Technologien",
  "mine.period.now": "heute",
  "mine.edu.degree": "Abschluss",
  "mine.edu.field": "Fach",
  "mine.skill.kind.language": "Programmiersprachen",
  "mine.skill.kind.framework": "Frameworks",
  "mine.skill.kind.tool": "Werkzeuge",
  "mine.skill.kind.platform": "Plattformen",
  "mine.skill.kind.domain": "Fachgebiete",
  "mine.skill.kind.practice": "Arbeitsweisen",
  "mine.skill.kind.human_language": "Sprachen",
  "mine.skill.kind.other": "Sonstiges",
  "mine.skill.level.native": "Muttersprache",
  "mine.skill.level.proficient": "sicher",
  "mine.skill.level.working": "gut",
  "mine.skill.level.familiar": "Grundkenntnisse",
  "mine.item.kind": "Art",
  "mine.item.publication": "Veröffentlichung",
  "mine.item.certification": "Zertifikat",
  "mine.item.award": "Auszeichnung",
  "mine.item.project": "Projekt",
  "mine.item.other": "Sonstiges",
  "mine.item.detail": "Details",
  "mine.item.date": "Datum",
  "mine.cv.file": "Datei",
  "mine.cv.first": "Zuerst hochgeladen",
  "mine.cv.last": "Zuletzt hochgeladen",
  "mine.cv.current": "Aktuell verwendet",
  "mine.yes": "ja",
  "mine.no": "nein",
  "mine.search.settings": "Sucheinstellungen",
  "mine.search.rules": "Geltende Regeln",
  "mine.search.reasons": "Eigene Gründe zum Aussortieren",
  "mine.search.switches": "Schalter",
  "mine.thread.kind": "Art",
  "mine.thread.started": "Begonnen",
  "mine.thread.files": "Dateien",
  "mine.thread.unsent": "Angehängt, aber nie gesendet",
  "mine.who.you": "Du",
  "mine.who.agent": "Agent",
  "mine.q.asked": "Vom Agenten gefragt",
  "mine.q.answer": "Deine Antwort",
  "mine.q.at": "Beantwortet",
  "mine.q.forms": "Antworten für Bewerbungsformulare",
  "mine.q.value": "Antwort",
  "mine.job.unknown": "Die Stelle ist nicht mehr gespeichert",
  "mine.job.reasons": "Gründe",
  "mine.job.note": "Notiz",
  "mine.job.sent": "Aus der Erweiterung gesendete Seiten",
  "mine.sent.url": "Adresse",
  "mine.sent.company": "Unternehmen",
  "mine.sent.state": "Ergebnis",
  "mine.sent.at": "Gesendet",
  "mine.iv.rounds": "Runden",
  "mine.iv.time": "Zeit",
  "mine.iv.minutes": "Dauer (Minuten)",
  "mine.iv.format": "Format",
  "mine.iv.interviewers": "Interviewer",
  "mine.iv.link": "Meeting-Link",
  "mine.iv.notes": "Notizen",
  "mine.iv.state": "Status",
  "mine.round.proposed": "Zeit offen",
  "mine.round.confirmed": "vereinbart",
  "mine.iv.sponsorSay": "Wie ansprechen",
  "mine.iv.sponsorConfirm": "Was klären",
  "mine.iv.notCovered": "Was das Material nicht abdeckt",
  "mine.iv.prepare": "Vorbereiten",
  "mine.iv.questions": "Mögliche Fragen",
  "mine.iv.skillNote": "Hinweis",
  "me.set.end.title": "Suche beenden oder neu beginnen",
  "me.set.end.ended": "Am %1 als beendet vermerkt.",
  "me.set.end.end": "Ich habe eine Stelle gefunden",
  "me.set.end.restart": "Wieder anfangen zu suchen",
  "me.set.end.honest": "„Ich habe einen Job gefunden“ hält die Suche an; „Wieder anfangen zu suchen“ startet sie neu. Bereits eingereihte Nachrichten bleiben davon unberührt — die schalten Sie oben bei den Kanälen ab.",
  "me.hc.work_lang": "Arbeitssprache",
  "me.hc.location_notes": "Ort und Arbeitsmodell",
  "me.hc.currency": "Währung",
  "me.hc.salary_floor": "Gehaltsuntergrenze",

  // ---- Übersicht (Block 4f): die sechs Phasen — blaue Karte, die Woche, ein Blick, was es tat, das Gespräch; Spiegel der Phase 0
  "action.confirm.time.yes": "Passt",
  "action.confirm.time.no": "Passt nicht",
  "action.confirm.criterion.yes": "Beiseitelegen",
  "action.confirm.criterion.no": "Behalten",
  "action.confirm.place_modes.yes": "Ja, dort auch",
  "action.confirm.place_modes.no": "Nein, dort alles",
  "home.scan.k": "Heute · Durchlauf",
  "home.scan.line": "Was ich Ihnen heute geschickt habe. Schwache Treffer bleiben nach Ihren Regeln draußen.",
  "home.scan.none": "Noch keine Suchergebnisse. Die erste Runde erscheint nach Ihrer ersten Suche.",
  "home.scan.untouched": "Diese Woche neu, unberührt",
  "home.scan.untouchedN": "hoch %1 · mittel %2",
  "home.scan.open": "Stellen öffnen →",
  "home.motion.k": "In Bewegung",
  "home.motion.closing": "Frist bald",
  "home.motion.closingNote": "Wie viele der gemerkten und vorgemerkten Stellen innerhalb von sieben Tagen schließen.",
  "home.motion.open": "Stellen öffnen →",
  "home.iv.k": "Nächstes Gespräch",
  "home.iv.today": "heute",
  "home.iv.tomorrow": "morgen",
  "home.iv.inDays": "in %1 Tagen",
  "home.iv.round": "Runde %1 · %2",
  "home.iv.prep": "Vorbereitung öffnen →",
  "home.iv.noRound": "Die Einladung ist da, die Zeit noch nicht notiert. Tragen Sie sie auf der Gesprächsseite ein, damit Kalender und Vorbereitung folgen.",
  "home.iv.write": "Zeit eintragen →",
  "home.offers.k": "In Bewegung",
  "home.offers.n": "%1 Angebote",
  "home.offers.open": "Vergleich öffnen →",
  "home.done.k": "Danach",
  "home.done.ended": "Am %1 als „Suche beendet“ vermerkt.",
  "home.done.scope": "Ihr Suchrahmen ist noch da",
  "home.done.scopeSub": "Regeln, Gemerktes und diese Aufstellung bleiben. Ein Schritt holt sie zurück.",
  "home.done.restart": "Neu anfangen →",
  "home.done.data": "Ihre Daten",
  "home.done.dataSub": "Exportieren Sie, was Sie uns gegeben haben (Lebenslauf, Profil, Einstellungen, Gespräche usw., mit einer maschinenlesbaren data.json).",
  "home.done.settings": "Zu den Einstellungen →",
  "home.done.say": "Nachrichten und der nächtliche Lauf",
  "home.done.saySub": "Bereits eingereihte Nachrichten gehen noch raus; danach läuft der nächtliche Lauf nicht mehr für Sie. Zum Neustart in den Einstellungen „Wieder anfangen zu suchen“ drücken.",
  "home.ledger.k": "%1 Wochen",
  "home.ledger.since": "seit %1",
  "home.ledger.week": "Die letzte Woche: %1 gelesen, %2 sehenswert.",
  "home.ledger.saved": "gemerkt",
  "home.ledger.applied": "beworben",
  "home.ledger.interview": "im Gespräch",
  "home.ledger.offer": "Angebote",
  "home.ledger.ruler": "Kumulativ: „beworben“ zählt auch die, aus denen Gespräche, Angebote oder Absagen wurden. Der Trichter auf der Stellenseite zählt den jetzigen Stand; beide sollen nicht übereinstimmen.",
  "home.week.k": "Mein Gesprächskalender",
  "home.week.all": "Ganzer Kalender →",
  "home.week.none": "Diese Woche keine Gespräche.",
  "home.story.title": "%1 Fragen zu Ihrer Erfahrung",
  "home.story.lede": "Optional. Ihre Antworten fließen in Ihren Profilüberblick ein, und die nächsten Suchen nutzen sie.",
  "home.story.open": "Antworten",
  "home.story.dialog": "Was Ihr Lebenslauf noch nicht ganz erklärt",
  "home.story.left": "noch %1",
  "home.story.answer": "Ihre Antwort",
  "home.story.answerPh": "Ein, zwei konkrete Fakten genügen.",
  "home.story.save": "Speichern",
  "home.story.skip": "Diese überspringen",
  "home.story.skipAll": "Alle überspringen",
  "home.story.note": "Wenn Sie dies schließen, wird Ihr Profilüberblick aus Ihren Antworten neu geschrieben – ab der nächsten Suche.",
  "home.story.failed": "Konnte nicht speichern (%1). Bitte erneut versuchen.",
  "home.story.gone": "Diese Frage gibt es nicht mehr: anderswo beantwortet, oder Ihr Lebenslauf hat sich geändert.",
  "home.story.closeFailed": "Ihre Antworten sind gespeichert, aber die Neufassung ließ sich nicht anstoßen (%1). Bitte erneut schließen.",
  "home.look.k": "Ein Blick",
  "home.look.lead": "Ein paar Dinge liegen noch auf dem Tisch und warten auf Sie.",
  "home.look.empty": "Heute wartet nichts auf Sie. Auch das ist ein Ergebnis.",
  "home.look.open": "Öffnen →",
  "home.look.today_ready": "Die heutige Auswahl ist da",
  "home.look.quiet_day": "Heute keine neuen hohen Treffer",
  "home.look.question": "Eine Frage wartet auf Ihre Antwort",
  "home.look.reply_seen": "%1 hat geantwortet",
  "home.look.prep_ready": "Die Vorbereitung für %1 steht",
  "home.look.report_ready": "Der Positionsbericht ist geschrieben",
  "home.look.time_confirm": "%1 schlägt eine Zeit vor — bestätigen",
  "home.look.offer_decision": "Das Angebot von %1 wartet auf Sie",
  "home.look.roundWhen": "%1 · %2 · Runde %3 · %4",
  "home.look.reschedule": "Verschieben auf der Gesprächsseite →",
  "home.look.pushed": "geschickt · %1",
  "home.did.k": "Was es tat",
  "home.did.teaser": "Heute %1 neue: %2 hoch / %3 mittel / %4 niedrig.",
  "home.did.teaserNone": "Für Sie wurde noch keine Stellensuche ausgeführt.",
  "home.did.run": "Letzter Lauf",
  "home.did.runLine": "Heute %1 neue Anzeigen, %2 durch Ihre harten Bedingungen, %3 beurteilt: %4 hoch / %5 mittel / %6 niedrig.",
  "home.did.budgetLeft": "Die übrigen Stellen aus diesem Lauf werden beim nächsten Mal beurteilt.",
  "home.did.runCite": "Quelle: der Lauf vom %1, %2–%3.",
  "home.did.learned": "Gelernt",
  "home.did.rule": "%1 · %2",
  "home.did.ruleCite": "Quelle: %1",
  // A rule as it stands once settled — one wording wherever a settled rule
  // is shown: the home's 学到, the divider under the conversation that
  // proposed it (Issue 556).
  "rule.settled.confirmed": "Beantwortet: notiert · %1",
  "rule.settled.declined": "Beantwortet: nein · %1",
  "rule.settled.retired": "Zurückgezogen · %1",
  "home.did.learnedNone": "Diese Woche keine neue Regel gelernt.",
  "home.talk.k": "Gespräch",
  "home.talk.title": "Jederzeit fragen",
  "home.first.k": "Erste Suche",
  "home.first.elsewhere": "überall sonst",
  "home.first.noMode": "keine Angabe",
  "home.first.nowhere": "nicht in Betracht",
  "home.first.progressTitle": "Der echte Markt wird jetzt durchsucht",
  "home.first.doneTitle": "Die erste Suche ist abgeschlossen",
  "home.first.stoppedTitle": "Die erste Suche ist stehen geblieben",
  "home.first.safe": "Sie können diese Seite verlassen; die Suche läuft im Hintergrund weiter.",
  "home.first.state.queued": "Eingereiht; wartet auf den Suchprozess.",
  "home.first.state.unknown": "Der Auftrag wurde übernommen; ein prüfbarer Laufdatensatz steht noch aus.",
  "home.first.state.failed": "Diese Suche wurde nicht fertig. Prüfbare Ergebnisse und der Fehlerzustand bleiben erhalten.",
  "home.first.state.stuck": "Die Suche hat länger keinen Fortschritt gemacht und braucht Aufmerksamkeit. Ihr prüfbarer Zustand bleibt erhalten.",
  "home.first.state.partial": "Diese Runde kam bis hierher; der Rest bleibt für die nächste.",
  "home.first.state.partialExtras": "Alle Stellen wurden gelesen. Einige Hintergrundarbeiten wurden diesmal nicht fertig; die Ergebnisse unten sind davon unberührt.",
  "home.first.state.done": "Die erste Suche ist fertig.",
  "home.first.phase.finding": "Auf dem Markt wird nach Stellen gesucht.",
  "home.first.phase.reading": "Die Stellen werden mit Ihren Kriterien abgeglichen.",
  "home.first.phase.extras": "Schon ansehbar: %1. Der Rest wird noch zusammengestellt.",
  "home.first.phase.more": "Es werden noch Stellen für Ihre weiteren Rollen und Orte gesucht.",
  "home.first.phase.moreReady": "Schon ansehbar: %1. Es werden noch Stellen für Ihre weiteren Rollen und Orte gesucht.",
  "home.first.phase.extrasEmpty": "Alle Stellen sind gelesen; keine davon ist diesmal ein anzeigbarer hoher oder mittlerer Treffer.",
  "home.first.phase.extrasEmptyLeft": "In den bisher gelesenen Quellen noch kein anzeigbarer hoher oder mittlerer Treffer; die übrigen werden heute Nacht gelesen.",
  "home.first.phase.sorting": "Alle Stellen sind gelesen; die Karten werden gerade erstellt.",
  "home.first.phase.stopping": "Bei dieser Suche ist etwas schiefgegangen; sie wird gerade beendet.",
  "home.first.state.cardsShort": "Alle Stellen wurden gelesen, aber einige ließen sich diesmal nicht als Karte aufbereiten; unten steht, was fertig wurde.",
  "home.first.retry": "Erste Suche erneut starten",
  "home.first.retrying": "Erneute Suche wird eingereiht…",
  "home.first.retryError": "Die erneute Suche konnte nicht eingereiht werden. Der bisherige Suchstatus bleibt unverändert.",
  "home.first.notifyTitle": "Optionale Benachrichtigungen",
  "home.first.notifyLede": "Verbinden Sie weitere Kanäle, damit Sie nichts verpassen.",
  "home.first.notify.email": "E-Mail",
  "home.first.notify.slack": "Slack",
  "home.first.notify.whatsapp": "WhatsApp",
  "home.first.notify.telegram": "Telegram",
  "home.first.resultsK": "Erste Auswahl",
  "home.first.resultsTitle": "Ihre ersten näher anzusehenden Stellen",
  "home.first.resultsSub": "%1 von %2 echten Treffern werden gezeigt.",
  "home.first.resultsSoFar": "Bisher %1 bereit – der Rest wird noch gelesen und kommt nach und nach dazu.",
  "home.first.empty": "Die erste Suche endete ohne anzeigbaren hohen oder mittleren Treffer. Counting AI lockert Ihre harten Bedingungen nicht, um die Liste zu füllen.",
  "home.first.emptyWaiting": "Die ersten Ergebnisse erscheinen hier. Die Suche läuft noch; fertige Stellen werden laufend ergänzt.",
  "home.first.emptyStopped": "Aus diesem Durchlauf sind noch keine Stellen anzeigbar. Die Karte zur ersten Suche erklärt, wo die Suche oder Aufbereitung angehalten hat.",
  "home.first.sourcesLeft": "%1 deiner Quellen konnten nicht rechtzeitig gelesen werden; sie werden heute Nacht gelesen, neue Stellen erscheinen morgen früh unter den heutigen Empfehlungen.",
  "home.first.emptySourcesLeft": "In den bisher gelesenen Quellen gibt es noch keinen anzeigbaren hohen oder mittleren Treffer; die übrigen werden heute Nacht gelesen, neue Stellen erscheinen morgen früh unter den heutigen Empfehlungen. Counting AI lockert deine harten Bedingungen nicht, um diese Liste zu füllen.",
  "home.first.open": "Öffnen",
  "home.first.all": "Alle Stellen ansehen →",
  "home.first.criteria": "Ihre Suchkriterien",
  "home.first.criteriaOpen": "Kriterien prüfen oder ändern →",
  "home.first.report": "Marktpositionsbericht",
  "home.first.reportOpen": "Bericht ansehen →",
  "home.first.reportWriting": "Der Bericht entsteht aus demselben Lebenslauf, Profil und Zielmarkt.",
  "home.first.reportFailed": "Der Bericht wurde diesmal nicht geschrieben; öffnen, um den Grund zu sehen oder neu zu versuchen.",
  "home.first.ask": "Zu dieser Auswahl fragen",
  "home.first.ask1": "Warum steht die erste Stelle ganz oben?",
  "home.first.ask2": "Welche Stelle passt am besten zu der Arbeit, die ich weiterführen möchte?",
  "home.first.askEmpty1": "Warum erfüllte keine Stelle meine harten Bedingungen?",
  "home.first.askEmpty2": "Welche Bedingung begrenzt den Markt am stärksten?",
  "home.first.opener.lead": "Diese Suche: %1 gelesen, davon einen genaueren Blick wert: %2.",
  "home.first.opener.topOne": "Ganz oben:",
  "home.first.opener.topTwo": "Die zwei obersten:",
  "home.first.opener.ask": "Fragen Sie mich, warum sie so gereiht sind oder welche am besten zu Ihnen passt – oder öffnen Sie eine in der Liste für die Details.",
  "home.first.opener.askOne": "Fragen Sie mich, warum sie ganz oben steht oder ob sie zu Ihnen passt – oder öffnen Sie sie in der Liste für die Details.",
  "home.first.opener.empty": "Das Werkzeug für die erste Auswahl fand keinen anzeigbaren hohen oder mittleren Treffer.",
  "home.first.opener.kept": "Ihre harten Bedingungen bleiben unverändert.",
  "home.first.opener.running": "Die erste Suche ist noch nicht fertig; gelesene Stellen erscheinen auf dieser Seite.",
  "home.first.opener.stopped": "Die erste Suche wurde diesmal nicht fertig.",
  "home.first.opener.change": "Wenn Sie die Kriterien ändern möchten, sagen Sie es — die nächste Runde nutzt sie.",
  "home.opener.reportTyping": "Standortbericht wird erstellt",
  "home.opener.reportOpen": "Standortbericht öffnen →",
  "home.opener.reportStalled": "Ihr Standortbericht wurde diesmal nicht geschrieben.",
  "home.opener.reportWhy": "Grund ansehen oder neu schreiben →",
  "home.opener.scan": "Heutiger Durchlauf: %1 hoch / %2 mittel / %3 niedrig. %4 hohe und %5 mittlere diese Woche noch unberührt. Regel ändern oder Stelle überspringen — sagen Sie es.",
  "home.opener.scanNone": "Für Sie wurde noch keine Stellensuche ausgeführt. Wollen Sie zuerst eine Regel ändern, sagen Sie es.",
  "home.opener.motion": "Die hohen Treffer von heute stehen auf dieser Seite. Fragen Sie, welchen Sie zuerst öffnen sollen, oder sagen Sie, was sich ändern soll.",
  "home.opener.iv": "%1 ist der Fixpunkt. Was durchzugehen ist, sagen Sie es.",
  "home.opener.ivNone": "Die Zeit des Gesprächs ist noch nicht notiert.",
  "home.opener.offers": "Wir können die Angebote hier durchgehen: wie sie sich vergleichen, was Sie verhandeln, ob Sie zusagen. Vertragsklauseln lege ich nicht aus.",
  "home.opener.done": "Die Suche ist beendet. Zum Neustart den Schalter in den Einstellungen drücken.",
  "home.stats.k": "Statistik",
  "home.stats.close": "Einklappen ▴",
  "home.stats.open": "Aufklappen ▾",
  "home.today.region": "Heutige Auswahl",
  "home.today.k": "Heute · %1",
  "home.today.title": "%1 hohe Treffer heute",
  "home.today.left": "Noch %1 offen, %2 schon beantwortet. Die mittleren und niedrigen Treffer stehen unter „Alle Empfehlungen von heute“.",
  "home.today.leftOnly": "Noch %1 offen. Die mittleren und niedrigen Treffer stehen unter „Alle Empfehlungen von heute“.",
  "home.today.none": "Heute noch keine neuen hohen Treffer. Die mittleren und niedrigen stehen unter „Alle Empfehlungen von heute“.",
  "home.today.unreadMay": "Von dieser Suche noch nicht genau gelesen: %1, die passen könnten.",
  "home.today.unreadUnlikely": "Von dieser Suche nicht genau gelesen: %1, deren Titel woandershin zeigen.",
  "home.today.unreadBoth": "Von dieser Suche noch nicht genau gelesen: %1, die passen könnten, und %2, deren Titel woandershin zeigen.",
  "home.today.allAnswered": "Sie haben alle hohen Treffer von heute beantwortet.",
  "home.today.batch": "Stapel %1 von %2 · je %3",
  "home.today.prev": "← Vorheriger",
  "home.today.next": "Nächster →",
  "home.today.more": "%1 weitere auf der Seite Stellen.",
  "home.today.answered": "Beantwortet · %1",
  "home.today.unfold": "Aufklappen ▾",
  "home.asks.motion.first": "Welche von heute lohnt sich zuerst?",
  "home.asks.motion.closest": "Welche kommt dem am nächsten, was ich weitermachen will?",
  "home.asks.motion.week": "Wie steht diese Woche im Vergleich zur letzten?",
  "home.asks.iv.likely": "Was fragt %1 wahrscheinlich?",
  "home.asks.iv.mock": "Mach ein Probeinterview mit mir",
  "home.asks.iv.week": "Passen die Interviews dieser Woche zusammen?",
  "home.asks.offers.pay": "Worauf sollte ich beim Verhandeln achten?",
  "home.asks.offers.before": "Was sollte ich vor dem Zusagen klären?",
  "home.ob.title": "Erst ein paar Worte",
  "home.ob.opener.resume": "Geben Sie mir zuerst den Lebenslauf — als PDF oder Word-Datei, oder fügen Sie Ihren Werdegang ein. Was ich daraus lesen kann, steht sofort rechts; ich frage nur, was ich nicht lesen kann.",
  "home.ob.opener.ask": "Ich frage nur die %1 Dinge, die ich nicht ableiten kann. Erstens: %2",
  "home.ob.ask.location_notes": "Wo möchten Sie arbeiten und wie oft möchten Sie ins Büro?",
  "home.ob.ask.work_lang": "In welchen Sprachen können Sie arbeiten?",
  "home.ob.ask.direction": "Welche Art Stelle suchen Sie? (Backend, Plattform, ML, Daten …)",
  "home.ob.ask.salary_floor": "Wo liegt Ihre Jahresgehaltsuntergrenze (brutto, %1)?",
  "home.ob.mirror": "Mein Profil",
  "home.ob.full": "Ganze Seite öffnen →",
  "home.ob.hint": "Hier steht nur, was das Gespräch schon geschrieben hat. Zum Ändern sagen Sie es im Gespräch — oder öffnen Mein Profil und bearbeiten den Block.",
  "home.ob.report": "Marktpositionsbericht",
  "home.ob.need": "Dafür brauche ich:",
  "home.ob.resume": "Lebenslauf",
  "home.ob.reportAfter": "Sind diese da, schreibe ich den Bericht im Gespräch.",
  "home.ob.reportFailed": "Der letzte Bericht wurde nicht geschrieben. Der Grund steht unter „Mein Profil“.",
  "home.ob.reportWriting": "Der Bericht wird geschrieben. Fertig steht er unter „Mein Profil“.",
  "home.ob.reportReady": "Alles da. Sagen Sie im Gespräch „schreib den Bericht“.",
  "home.ob.reportDone": "Neueste · %1 · öffnen →",
  "home.ob.resumeNone": "Noch nichts. Nach dem Hochladen erscheinen Stationen und Fähigkeiten hier.",
  "home.ob.resumeMeta": "%1 · %2 Stationen · %3 Abschlüsse · %4 Fähigkeiten",
  "home.ob.upload": "Lebenslauf hochladen",
  "home.ob.uploading": "Lädt hoch…",
  "home.ob.tooBig": "Über 10MB",
  "home.ob.profile": "Profil",
  "home.ob.profileNone": "„Wer Sie sind“ kommt aus dem Lebenslauf. Erst hochladen.",
  "home.ob.hc": "Harte Bedingungen und Ziel",
  "home.ob.notAsked": "Noch nicht gefragt",
  "home.ob.said": "von Ihnen",
  "home.ob.resumeSrc": "aus dem Lebenslauf",
  "home.ob.inferred": "abgeleitet",
  "home.ob.q": "Die paar, die ich nicht ableiten konnte",
  // the admin pages (block 5b)
  "admin.title": "Verwaltung",
  "admin.nav.label": "Verwaltungsnavigation",
  "admin.nav.runs": "Läufe",
  "admin.nav.log": "Zugriffe",
  "admin.nav.models": "Modelle",
  "admin.nav.sources": "Quellen",
  "admin.nav.render": "Übersetzungen",
  "admin.nav.eval": "Abgleich",
  "admin.nav.spend": "Modellkosten",
  "admin.nav.payments": "Payments",
  "admin.spend.head": "Modellkosten",
  "admin.spend.lede": "Every paid model call is a row in the ledger (model_spend) the moment it is paid. Summed here per person and per day in their own time zone; open a cell for that day call by call. Ids, addresses, steps, models, dollars and tokens only — no text. Rows stay 90 days, then are archived a file a day to the archive bucket.",
  "admin.spend.cap": "Limit pro Person und Tag (budgets.user.day): %1",
  "admin.spend.capNone": "Kein Limit pro Person und Tag (budgets.user.day)",
  "admin.spend.portalNot": "The portal's own calls (chat and the like) are not in it yet",
  "admin.spend.none": "Nothing in the ledger in the last 8 days.",
  "admin.spend.col.who": "Wer",
  "admin.spend.market": "Everybody's (market, UTC days)",
  "admin.spend.ledger": "Ledger",
  "admin.spend.runs": "What the day's runs said",
  "admin.spend.reckonNote": "A run counts on the day it started: one that crossed midnight shows a difference on both days without a row missing.",
  "admin.spend.day": "%1 am %2: %3, %4 Aufrufe",
  "admin.spend.times": "Times in %1; the day is cut in the person's own time zone",
  "admin.spend.dayNone": "Nothing that day.",
  "admin.spend.col.at": "Zeit",
  "admin.spend.col.run": "Lauf · Schritt",
  "admin.spend.col.task": "Aufgabe",
  "admin.spend.col.model": "Modell · Backend",
  "admin.spend.col.usd": "Kosten",
  "admin.spend.col.tokens": "Tokens ein / aus",
  "admin.payments.head": "Refused payments",
  "admin.payments.lede": "Stripe payments that were paid and that the function opening accounts (fulfil) refused: a price that is not the plan's, an account that is gone. One row each, the ones nobody has seen to first. The account's end date was not changed.",
  "admin.payments.none": "No refused payments.",
  "admin.payments.open": "Not seen to: %1",
  "admin.payments.col.at": "When",
  "admin.payments.col.who": "Account",
  "admin.payments.col.plan": "Plan",
  "admin.payments.col.amount": "Amount",
  "admin.payments.col.why": "Why",
  "admin.payments.col.session": "Checkout Session",
  "admin.payments.col.state": "State",
  "admin.payments.gone": "account gone",
  "admin.payments.deleting": "being deleted",
  "admin.payments.unresolved": "not seen to",
  "admin.payments.honoured": "honoured as well — nothing to do",
  "admin.payments.resolved": "seen to %1: %2",
  "admin.payments.capped": "The latest %1 only.",
  "admin.payments.how": "To see to one: add the time with python -m pipeline.cli grant, or refund it in Stripe's dashboard (the session opens the payment there); then python -m pipeline.cli payment-resolve <session> --note \"what was done\", and the notice on their billing page goes away.",
  "admin.nav.back": "← Zurück zum Portal",
  "admin.whoDev": "Entwicklung: Hier steht keine Tür davor, wer sie öffnet, gilt als Admin.",
  "admin.runs.head": "Läufe",
  "admin.runs.lede": "Abrufen, Bewerten, Übersetzen, Recherche und was eine Seite angefordert hat — was jedes Segment tat, wie weit es kam, was es kostete. Was eingereiht liegen blieb oder nicht mehr atmet, steht oben.",
  "admin.runs.none": "Noch nichts aufgezeichnet. Der nächste geplante Lauf schreibt die erste Zeile.",
  "admin.runs.waiting": "%1 eingereiht und noch nicht übernommen",
  "admin.runs.waitingNote": "Vom Portal geschrieben, wartet auf den Drain der Pipeline. Lauter alte Zeilen heißen: kein Drain läuft.",
  "admin.runs.stalled": "%1 ohne Herzschlag",
  "admin.runs.unlikely": "Die Titelstufe „unlikely“ enthält zeigenswerte Stellen: %1 von %2 in den letzten %3 Tagen gezogenen",
  "admin.runs.unlikelyNote": "95-%-Intervall %1–%2, die Untergrenze über %3. Geplante Suchen lesen diese Stufe nur stichprobenweise; rates.judge.read_unlikely auf 1 erwägen. Die ops-Prüfung von %4.",
  "admin.runs.stalledNote": "Ihr Zustand sagt noch „läuft“, doch der Herzschlag steht seit über %1 Minuten. Das ops-Segment schreibt den Zustand „hängt“ erst nach drei Stunden; bis dahin sagt es nur diese Zeile.",
  "admin.runs.clock": "Zeitgesteuerte Aufgaben",
  "admin.runs.clockWoke": "Der Taktgeber ist zuletzt aufgewacht: %1",
  "admin.runs.clockNever": "Noch kein Drain ist aufgewacht: niemand stellt die zeitgesteuerten Aufgaben ein.",
  "admin.runs.clockAsleep": "Der Taktgeber ist seit %1 Min. nicht aufgewacht: niemand stellt die zeitgesteuerten Aufgaben ein.",
  "admin.runs.clockAsleepNote": "Der laufende Drain stellt alle zeitgesteuerten Aufgaben ein (es gibt keine Crontab). Nach %1 Minuten ohne Aufwachen ist er gestoppt oder hängt: prüfe seine systemd-Unit oder führe auf dem Server cli schedule aus.",
  "admin.runs.clockZones": "Zeitzonen: %1",
  "admin.runs.clockNext": "nächste %1",
  "admin.runs.clockLast": "zuletzt %1 · %2",
  "admin.runs.clockNotYet": "noch nicht fällig",
  "admin.runs.notes": "Morgennotizen vom %1, %2",
  "admin.runs.nights": "Nächte vom %1, %2",
  "admin.runs.runs": "Letzte Läufe",
  "admin.runs.capped": "Die letzten %1 Läufe.",
  "admin.log.capped": "Die %1 zuletzt gesehenen Adressen von %2.",
  "admin.runs.silent": "%1 Min still",
  "admin.runs.took": "Dauer %1",
  "admin.runs.steps": "Schritte",
  "admin.runs.col.state": "Zustand",
  "admin.runs.col.did": "Erledigt",
  "admin.runs.col.cost": "Kosten",
  "admin.runs.col.took": "Dauer · Notiz",
  "admin.runs.market": "Markt",
  "admin.runs.open": "öffnen",
  "admin.runs.close": "schließen",
  "admin.runs.gate": "Das Gatter wies %1 Modellausgaben zurück",
  "admin.state.running": "läuft",
  "admin.state.ready": "fertig",
  "admin.state.partial": "teilweise",
  "admin.state.failed": "fehlgeschlagen",
  "admin.state.stuck": "hängt",
  "admin.step.running": "läuft",
  "admin.step.ok": "ok",
  "admin.step.partial": "teilweise",
  "admin.step.skipped": "übersprungen",
  "admin.step.failed": "fehlgeschlagen",
  "admin.log.head": "Zugriffe",
  "admin.log.lede": "Wer hier war, woher, wie oft. Ein Besuch ist eine Folge von Anfragen ohne Lücke über %1 Minuten.",
  "admin.log.none": "Noch nichts aufgezeichnet. Die nächste geöffnete Seite schreibt die erste Zeile.",
  "admin.log.ip": "IP-Adresse",
  "admin.log.place": "Ort",
  "admin.log.device": "Gerät",
  "admin.log.first": "Zuerst",
  "admin.log.last": "Zuletzt",
  "admin.log.n": "Besuche",
  "admin.log.total": "%1 Adressen, %2 Besuche, %3 Anfragen",
  "admin.log.local": "dieser Rechner",
  "admin.log.unknown": "unbekannt",
  "admin.log.zone": "Zeiten in %1",
  "admin.log.theirTime": "in %1-Zeit lesen",
  "admin.log.myTime": "in meiner Zeit lesen",
  "admin.log.visits": "%1 Besuche",
  "admin.log.requests": "%1 Anfragen",
  "admin.log.entry": "Einstieg",
  "admin.log.from": "von",
  "admin.log.lang": "Sprache",
  "admin.log.signedIn": "angemeldet als %1",
  "admin.log.gone": "Keine Aufzeichnung zu dieser Adresse.",
  "admin.log.visit": "Dieser Besuch",
  "admin.log.backToIp": "← %1",
  "admin.log.backToAll": "← Alle Adressen",
  "admin.dev.mobile": "Handy",
  "admin.dev.tablet": "Tablet",
  "admin.dev.desktop": "Desktop",
  "admin.dev.bot": "Bot",
  "admin.dev.unknown": "unbekannt",
  "admin.models.head": "Modelle",
  "admin.models.lede": "Welches Modell welche Aufgabe erledigt, so wie es gerade gilt. models.json oder die lokale Überschreibung ändern, der nächste Aufruf nutzt sie, ohne Neustart. Diese Seite liest nur.",
  "admin.models.task": "Aufgabe",
  "admin.models.model": "Modell",
  "admin.models.source": "Aus",
  "admin.models.price": "Preis je Million",
  "admin.models.ceiling": "Antwortgrenze",
  "admin.models.backend": "Bedient von",
  "admin.models.why": "Warum",
  "admin.models.src.env": "Umgebung",
  "admin.models.src.local": "dieser Rechner",
  "admin.models.src.repo": "Repository",
  "admin.models.files": "Repository %1",
  "admin.models.localHere": "Lokale Überschreibung %1 (vorhanden)",
  "admin.models.localGone": "Lokale Überschreibung %1 (fehlt)",
  "admin.models.prices": "Preise geprüft am %1",
  "admin.models.broken": "models.json lädt nicht: %1",
  "admin.models.noPrice": "kein Preis",
  "admin.src.head": "Quellen",
  "admin.src.lede": "Die Stellen stammen von diesen Boards. Eine Zeile ist das Board einer Firma in einem System; „gewollt“ zählt, wie viele Quellenlisten es beim letzten Abruf angefordert haben – vor jedem Abruf werden die Listen neu berechnet –, und null heißt, dieser Abruf ging daran vorbei.",
  "admin.src.none": "Keine Boards passen.",
  "admin.src.search": "Boards und Firmen suchen",
  "admin.src.board": "Board",
  "admin.src.company": "Firma",
  "admin.src.origin": "Herkunft",
  "admin.src.read": "Zuletzt gelesen",
  "admin.src.count": "Letzte Anzahl",
  "admin.src.open": "Offen",
  "admin.src.chosen": "Gewollt",
  "admin.src.never": "nie gelesen",
  "admin.src.totals": "%1 Boards · %2 offene Stellen · %3 Nutzer haben Quellen gewählt",
  "admin.src.unwanted": "%1 will niemand",
  "admin.src.unread": "%1 nie gelesen",
  "admin.src.dormant": "ruht seit %1",
  "admin.src.failing": "%1× in Folge fehlgeschlagen seit %2",
  "admin.src.partial": "nur teilweise gelesen seit %1",
  "admin.src.partialN": "%1 nur teilweise gelesen (schließt nichts auf ihr Wort hin: ihre Stellen schließen derweil über die eigene Seite)",
  "admin.src.dormantN": "%1 ruhend (antwortet nicht: hält die Stellen der Firma nicht mehr offen; wird weiter jede Nacht gelesen und wacht auf, sobald es antwortet)",
  "admin.src.noChoosers": "Noch kein Nutzer hat select_sources ausgeführt, daher ist „gewollt“ überall null und der nächtliche Lauf liest alle.",
  "admin.src.agg": "Sammelquellen",
  "admin.src.aggNone": "Noch keine Seite einer Sammelquelle gefunden. Der nächtliche Durchlauf sucht in jedem Land, in dem jemand sucht.",
  "admin.src.sort.read": "zuletzt gelesen",
  "admin.src.sort.open": "offene Stellen",
  "admin.src.sort.board": "Name",
  "admin.src.sort.chosen": "gewollt",
  "admin.src.sortBy": "Sortierung",
  "admin.src.origin.registry": "Register",
  "admin.src.origin.lead": "Hinweis",
  "admin.src.origin.discover": "entdeckt",
  "admin.src.origin.paste": "eingefügt",
  "admin.src.origin.seed": "gesät",
  "admin.src.clear": "zurücksetzen",
  "admin.render.head": "Übersetzungscache",
  "admin.render.lede": "Vom Modell geschriebener Text auf der Seite kommt in der Oberflächensprache aus diesem Cache; was fehlt, stellt das Portal ein und das Render-Segment schreibt es. Hier stehen nur Zahlen, Verträge, Sprachen, Engines und Fehlergründe – nie ein Original oder eine Übersetzung.",
  "admin.render.window": "Letzte 7 Tage = ab %1, Zeit %2",
  "admin.render.stale": "%1 vor über %2 Minuten beansprucht und nie fertig geworden",
  "admin.render.staleNote": "Noch als laufend markiert: Der Lauf, der sie beanspruchte, ist abgestürzt oder abgelaufen. Das Portal stellt sie beim nächsten Anzeigen neu ein (außer die Versuche sind aufgebraucht), der Versuch ist schon gezählt; bleibt das stehen, scheitert das Render-Segment immer wieder.",
  "admin.render.cache": "Cache",
  "admin.render.cacheNone": "Noch nichts im Cache.",
  "admin.render.engines": "Engine: legacy ist eine alte Übersetzung, die render-backfill übernommen hat, same ist ein Original schon in der Zielsprache (kostenlos), alles andere ist das Modell, das sie schrieb. Zeichen zählen am Original.",
  "admin.render.col.contract": "Vertrag",
  "admin.render.col.lang": "Nach",
  "admin.render.col.engine": "Engine",
  "admin.render.col.week": "Letzte 7 Tage",
  "admin.render.col.all": "Insgesamt",
  "admin.render.col.rows": "Zeilen",
  "admin.render.col.chars": "Zeichen",
  "admin.render.col.cost": "Kosten",
  "admin.render.col.day": "Tag",
  "admin.render.col.state": "Status",
  "admin.render.col.now": "Jetzt",
  "admin.render.col.asked": "Angefragt, letzte 7 Tage",
  "admin.render.col.reason": "Grund",
  "admin.render.col.n": "Anzahl",
  "admin.render.col.last": "Zuletzt",
  "admin.render.total": "Summe",
  "admin.render.days": "Pro Tag geschrieben",
  "admin.render.requests": "Wartende Anfragen",
  "admin.render.requestsNone": "Nichts wartet, läuft oder ist fehlgeschlagen.",
  "admin.render.state.queued": "wartet",
  "admin.render.state.running": "läuft",
  "admin.render.state.failed": "fehlgeschlagen",
  "admin.render.state.refused": "abgelehnt",
  "admin.render.oldest": "Die älteste wartet seit %1, %2 Min.",
  "admin.render.givenUp": "%1 schon %2-mal versucht, kein automatischer Neuversuch mehr",
  "admin.render.failures": "Fehlergründe (Top 10)",
  "admin.render.failuresNone": "Keine fehlgeschlagenen Anfragen.",
  "admin.render.masked": "Gründe erscheinen nur nach Art: keine Zahl, kein Link und kein Text, den sie zitieren; was keiner Art entspricht, zählt als „other“.",
  "admin.render.gate": "Vom Gatter abgelehnt (letzte 7 Tage)",
  "admin.render.gateNone": "Das Gatter hat in den letzten 7 Tagen keine Render-Ausgabe abgelehnt.",
  // the matching report (#929)
  "admin.eval.head": "Abgleich mit Entscheidungen",
  "admin.eval.lede": "Wie weit Anzeige, Bewertung, Einstufung und Reihenfolge des Judges mit den tatsächlichen Entscheidungen übereinstimmen. Für eine Person neu berechnet, sobald sie genug Stellen bearbeitet hat; die Gesamtsicht ist die Summe der jeweils neuesten.",
  "admin.eval.threshold": "Schwelle: ein Bericht je %1 bearbeitete Stellen",
  "admin.eval.swept": "Zuletzt geprüft %1",
  "admin.eval.neverSwept": "Noch nicht geprüft",
  "admin.eval.caveats": "Was die Zahlen sagen und was nicht",
  "admin.eval.caveat.exposure": "Sichtbarkeit: entschieden wird nur über Gezeigtes. Die Quoten beziehen sich auf gezeigte und bearbeitete Stellen; Unbearbeitetes zählt weder mit noch als Absage.",
  "admin.eval.caveat.newest": "Maßgeblich ist die geltende (neueste) Entscheidung; eine Rücknahme auf nichts gilt als unbearbeitet.",
  "admin.eval.caveat.rejudged": "Nur die neueste Bewertung bleibt: nach der Entscheidung neu bewertete zählen mit dem neuen Urteil (Anzahl unten).",
  "admin.eval.caveat.score": "Die Bewertung nutzt die heutigen Gewichte und das Alter der Stelle am Entscheidungstag; die Stufen nutzen die beim Lesen geltenden Grenzen.",
  "admin.eval.caveat.rank": "Reihenfolge: die Position in der Lesereihenfolge der Nacht, in der bewertet wurde (rank_grade, seit 0109); Früheres zählt als „kein Eintrag“.",
  "admin.eval.overall": "Alle",
  "admin.eval.none": "Noch kein Bericht. Der erste entsteht bei der nächsten Prüfung, nachdem jemand %1 Stellen bearbeitet hat.",
  "admin.eval.personHead": "Bericht für %1",
  "admin.eval.personNone": "Für diese Person gibt es noch keinen Bericht.",
  "admin.eval.personClose": "Schließen",
  "admin.eval.people": "Personen",
  "admin.eval.peopleNone": "Noch hat niemand etwas entschieden.",
  "admin.eval.col.user": "Person",
  "admin.eval.col.fresh": "Seit dem letzten bearbeitet / Schwelle",
  "admin.eval.col.lastReport": "Letzter Bericht",
  "admin.eval.col.lastDecision": "Letzte Entscheidung",
  "admin.eval.never": "Noch keiner",
  "admin.eval.history": "Verlauf",
  "admin.eval.historyNone": "Noch nichts berechnet.",
  "admin.eval.col.at": "Wann",
  "admin.eval.col.whose": "Wessen",
  "admin.eval.col.trigger": "Auslöser",
  "admin.eval.col.upto": "Bis Entscheidung",
  "admin.eval.everyone": "Alle",
  "admin.eval.trigger.auto": "Automatisch (Schwelle)",
  "admin.eval.trigger.manual": "Von Hand (Kommandozeile)",
  "admin.eval.col.positive": "Gewollt",
  "admin.eval.col.maybe": "Gemerkt",
  "admin.eval.col.passed": "Abgelehnt",
  "admin.eval.oldShape": "Der Bericht vom %1 hat ein älteres Format; der nächste ersetzt ihn.",
  "admin.eval.counted": "Berechnet %1: %2 Stellen bearbeitet, %3 Personen",
  "admin.eval.notes": "von den gezeigten %1 nach der Entscheidung neu bewertet, %2 von Hand eingestuft",
  "admin.eval.col.what": "Stellen",
  "admin.eval.shown": "Gezeigt (Grundlage der Quoten)",
  "admin.eval.hidden": "Vom Judge nicht gezeigt (gewollt = verpasst)",
  "admin.eval.unjudged": "Keine Bewertung (selbst mitgebracht oder Stelle entfernt)",
  "admin.eval.byBand": "Nach Stufe (Grenzen high %1 / mid %2)",
  "admin.eval.col.band": "Stufe",
  "admin.eval.col.rate": "Gewollt (95%-Intervall)",
  "admin.eval.col.kept": "Gewollt oder gemerkt (95%-Intervall)",
  "admin.eval.curve": "Nach Bewertung (Zwanzigstel)",
  "admin.eval.col.score": "Bewertung",
  "admin.eval.rank": "Nach Titelstufe und Position in der Nacht",
  "admin.eval.col.grade": "Titelstufe",
  "admin.eval.grade.likely": "likely",
  "admin.eval.grade.maybe": "maybe",
  "admin.eval.grade.unlikely": "unlikely",
  "admin.eval.grade.none": "Keine Stufe (wie maybe)",
  "admin.eval.grade.absent": "Kein Eintrag",
  "admin.eval.col.place": "Position",
  "admin.eval.firstK": "Anteil unter den ersten %1",
  "admin.eval.reasons": "Ablehnungsgründe (gezeigte Stellen)",
  "admin.eval.reasonsNone": "Noch keine Gründe angegeben.",
  "admin.eval.col.reason": "Grund",
  "admin.eval.col.total": "Anzahl",
  "admin.eval.custom": "Eigene Gründe",
  // ---- Anmelden / Registrieren / Probewoche (Block 6)
  "auth.signIn": "Anmelden",
  "auth.signUp": "Registrieren",
  "auth.email": "E-Mail",
  "auth.password": "Passwort",
  "auth.forgot": "Passwort vergessen",
  "auth.other": "Mit einem anderen Konto anmelden",
  "auth.google": "Mit Google fortfahren",
  "auth.noAccount": "Noch kein Konto?",
  "auth.toSignUp": "Registrieren →",
  "auth.haveAccount": "Schon ein Konto?",
  "auth.toSignIn": "Anmelden →",
  "auth.signOut": "Abmelden",
  "auth.signedOut": "Sie sind abgemeldet.",
  "auth.working": "Einen Moment…",
  "auth.signOutFailed": "Abmelden fehlgeschlagen. Bitte erneut versuchen.",
  // die 503-Seite, wenn die Sitzung nicht nachgeschlagen werden kann (Issue 260)
  "unavailable.title": "Dienst vorübergehend nicht verfügbar",
  "unavailable.body": "Laden Sie die Seite gleich neu. Sie müssen sich nicht erneut anmelden.",
  "unavailable.retry": "Neu laden",
  // der sechsstellige Code
  "auth.code.head": "Bitte E-Mails prüfen",
  "auth.code.sent": "Ein 6-stelliger Code ist unterwegs an %1. Er gilt %2 Minuten.",
  "auth.code.label": "Code",
  "auth.code.submit": "Bestätigen und weiter",
  "auth.code.resend": "Erneut senden",
  "auth.code.resendIn": "In %1s erneut möglich",
  "auth.code.another": "Andere Adresse verwenden",
  "auth.code.devNote": "Auf diesem Rechner ist kein Mailkonto eingerichtet; der Code steht in der Server-Konsole.",
  // Fehlermeldungen. %1 ist eine Anzahl Minuten oder die verbleibenden Versuche
  "auth.err.email": "Bitte eine Adresse, unter der Sie Post lesen können.",
  "auth.err.password": "Ein Passwort mit mindestens 10 Zeichen.",
  "auth.err.credentials": "Adresse und Passwort passen nicht zusammen.",
  "auth.err.locked": "Zu viele Versuche. In %1 Minuten wieder möglich.",
  "auth.err.code": "Der Code stimmt nicht. Noch %1 Versuche.",
  "auth.err.codeGone": "Dieser Code ist abgelaufen oder verbraucht. Fordern Sie einen neuen an.",
  "auth.err.tooMany": "Das sind viele Mails in kurzer Zeit. Bitte später erneut.",
  "auth.err.tooManyWait": "Das sind viele Mails in kurzer Zeit. In %1s erneut möglich.",
  "auth.err.mail": "Die Mail ging nicht raus. Bitte gleich noch einmal.",
  "auth.err.failed": "Das hat nicht geklappt. Bitte gleich noch einmal.",
  "auth.err.google": "Mit Google hat es nicht geklappt. Versuchen Sie es erneut oder melden Sie sich mit Adresse und Passwort an.",
  "auth.err.session": "Sie wurden abgemeldet. Bitte erneut anmelden.",
  // Die zwei Briefe — an ein Postfach, nicht an eine Seite — in der Sprache
  // der Seite. %1 der Code, %2 die Minuten
  "auth.mail.code.subject": "Ihr Counting-AI-Bestätigungscode",
  "auth.mail.code.body": "Code: %1\n\nTragen Sie ihn auf der offenen Seite ein. Er gilt %2 Minuten.\nWaren Sie das nicht, ignorieren Sie diesen Brief; es ist nichts passiert.",
  "account.email.oneOnly": "Ihre Anmelde-E-Mail ist zugleich die einzige Benachrichtigungsadresse. Die neue Adresse muss zuerst bestätigt werden; danach wird die alte nicht mehr verwendet.",
  "account.email.new": "Neue E-Mail",
  "account.email.send": "Neue E-Mail bestätigen",
  "account.email.code": "Bestätigungscode",
  "account.email.verify": "Änderung bestätigen",
  "account.email.cancel": "Abbrechen",
  "account.email.sent": "Ein Code wurde an die neue Adresse gesendet. Bis zur erfolgreichen Bestätigung bleibt die bisherige Adresse unverändert.",
  "account.email.taken": "Diese E-Mail gehört bereits zu einem anderen Konto. Nutzen Sie damit die Anmeldung oder die Kontowiederherstellung.",
  "account.email.same": "Das ist bereits die aktuelle Anmelde-E-Mail.",
  "account.email.wrong": "Der Code ist nicht richtig. Versuchen Sie es erneut.",
  "account.email.rate": "Bitte warten Sie, bevor Sie einen weiteren Bestätigungscode senden.",
  "account.email.failed": "Die E-Mail wurde nicht geändert. Der Code könnte abgelaufen sein; senden Sie einen neuen.",
  "account.email.mailSubject": "Neue Counting-AI-E-Mail bestätigen",
  "account.email.mailBody": "Code: %1\n\nGeben Sie ihn innerhalb von %2 Minuten in den Counting-AI-Einstellungen ein. Bis zur Bestätigung bleibt die alte E-Mail aktuell. Wenn Sie das nicht waren, ignorieren Sie diese Nachricht.",
  "auth.mail.exists.subject": "Zu dieser Adresse gibt es bereits ein Counting-AI-Konto",
  "auth.mail.exists.body": "Jemand hat gerade versucht, sich mit dieser Adresse zu registrieren; es gibt bereits ein Konto, daher wurde nichts angelegt.\n\nWaren Sie das: melden Sie sich an, oder nutzen Sie \"Passwort vergessen\".\nWaren Sie das nicht: ignorieren Sie diesen Brief. An Ihrem Konto hat sich nichts geändert.",
  "auth.mail.none.subject": "Zu dieser Adresse gibt es kein Counting-AI-Konto",
  "auth.mail.none.body": "Jemand wollte gerade ein Counting-AI-Passwort für diese Adresse zurücksetzen; zu ihr gehört kein Konto, es wurde also nichts geändert.\n\nWaren Sie das: die Registrierung ist der richtige Ort.\nWaren Sie das nicht: ignorieren Sie diesen Brief.",
  "auth.err.taken": "Zu dieser Adresse gibt es bereits ein Konto — bitte anmelden.",
  // Passwort neu setzen
  "auth.reset.head": "Passwort neu setzen",
  "auth.reset.lede": "Geben Sie Ihre Adresse an, wir schicken einen Code.",
  "auth.reset.new": "Neues Passwort",
  "auth.reset.submit": "Dieses Passwort setzen",
  "auth.reset.sent": "Falls es zu dieser Adresse ein Konto gibt, ist ein Code unterwegs.",
  "auth.reset.done": "Das Passwort ist geändert, alle anderen Geräte wurden abgemeldet.",
  // Probewoche und danach (§21)
  "billing.head": "Abonnement",
  "billing.active": "Ihr Abonnement läuft.",
  "billing.trialLeft": "Noch %1 Tage Probezeit",
  "billing.trialLeftOne": "Noch 1 Tag Probezeit",
  "billing.trialEndsOn": "Probezeit läuft bis %1",
  "billing.expired": "Die Probewoche ist vorbei.",
  "billing.lede": "Ihre Daten sind noch da und Sie können sie mitnehmen. Zum Weiterbenutzen oder um Konto und Daten löschen zu lassen, schreiben Sie uns.",
  "billing.lede.paid": "Das Abonnement läuft; es ist nichts zu tun. Die Schaltfläche unten steht jederzeit bereit, um Ihre Daten mitzunehmen; um Konto und Daten löschen zu lassen, schreiben Sie uns.",
  "billing.contact": "Schreiben Sie uns zum Freischalten →",
  "billing.write": "Schreiben Sie uns →",
  "billing.export": "Meine Daten exportieren",
  "billing.signedInAs": "Angemeldet als %1",
  "billing.back": "Zurück zum Portal",
  "billing.plan.month.name": "1 month",
  "billing.plan.quarter.name": "3 months",
  "billing.plan.year.name": "12 months",
  "billing.plan.month.item": "Prospect · 1 month",
  "billing.plan.quarter.item": "Prospect · 3 months",
  "billing.plan.year.item": "Prospect · 12 months",
  "billing.perMonth": "%1 a month",
  "billing.off": "Save %1%",
  "billing.buy": "Buy",
  "billing.renew": "Renew",
  "billing.subscribe": "Subscribe",
  "billing.opening": "Opening the payment page…",
  "billing.methods": "%1",
  "billing.method.apple_pay": "Apple Pay",
  "billing.method.google_pay": "Google Pay",
  "billing.method.alipay": "Alipay",
  "billing.method.wechat_pay": "WeChat Pay",
  "billing.once": "One payment; nothing renews by itself.",
  "billing.lede.buy": "Pick how long, and it opens up as soon as you have paid. Your data is all still there.",
  "billing.lede.early": "Buying now does not waste the rest of the trial: it starts from the day the trial ends.",
  "billing.lede.renew": "Renewing adds on from your current end date.",
  "billing.lede.delete": "To have the account and its data deleted, write to us.",
  "billing.paidUntil": "Paid up until %1",
  "billing.success.head": "Payment received",
  "billing.success.until": "%1 added — you're set until %2.",
  "billing.success.see": "See your subscription",
  "billing.pending": "This payment is not confirmed yet. If you have paid, give it a moment and refresh this page.",
  "billing.refused": "We received a payment from you but could not open your account with it automatically. A person will see to it soon — the time added, or the money refunded.",
  "billing.refusedWrite": "We received a payment from you but could not open your account with it automatically. A person will see to it soon — the time added, or the money refunded. Questions: write to %1.",
  "billing.err.off": "Paying online is not available yet; write to us to open the account.",
  "billing.err.stripe": "Could not open the payment page. Please try again later.",
  "billing.err.failed": "Could not open the payment page. Check your connection and try again.",
  // A button pressed on a push, on any transport (press.*, #626); Slack's own lines and the modal behind the ones that need words (slack.*, #256).
  "press.chose": "Gewählt: %1",
  "press.failed": "Das ist nicht angekommen; antworte auf der Website.",
  "press.answered": "Diese Frage ist bereits beantwortet.",
  "press.decision.new": "unentschieden",
  "press.decision.same": "Diese Stelle ist bereits „%1“.",
  "press.decision.change": "Diese Stelle ist derzeit „%1“. Zu „%2“ ändern?",
  "press.decision.changed": "Von „%1“ zu „%2“ geändert.",
  "slack.decision.moved": "Diese Stelle wurde inzwischen zu „%1“ geändert. Nutze die Nachricht erneut, um sie zu ändern.",
  "press.trialOver": "Deine Probewoche ist vorbei; sieh auf der Website nach.",
  "press.moved": "Diese Stelle wurde eben anderswo zu „%1“ geändert. Zum Ändern noch einmal drücken.",
  "press.reasons": "Warum nicht? Beliebige Gründe wählen, oder keinen; für mehr „Grund schreiben“ drücken. Dann „Absenden“ drücken.",
  "press.submitFor": "Absenden · %1",
  "press.note": "Grund schreiben",
  "press.noteAsk": "Antworte auf diese Nachricht: Warum passt „%1“ nicht?",
  "press.notePlaceholder": "Warum es nicht passt",
  "press.noteSaved": "Notiert. Wenn die Gründe gewählt sind, „%1“ drücken.",
  "press.noteLate.submitted": "Diese Stelle wurde schon abgeschickt; dieser Grund wurde nicht gespeichert.",
  "press.noteLate.cancelled": "Die Gründe wurden abgebrochen; dieser Grund wurde nicht gespeichert.",
  "press.noteLost": "Dein Grund wurde nicht gespeichert: Diese Stelle wurde schon anderswo entschieden.",
  "press.cancel": "Abbrechen",
  // A Telegram morning's three answers, a third of a phone's row each (#765): shorter than the card's own (card.goApply …).
  "press.pick.preparing": "Bewerben",
  "press.pick.maybe": "Merken",
  "press.pick.passed": "Nein",
  "press.changeTo": "Ändern zu „%1“",
  "press.onSite": "Das wird auf der Website beantwortet.",
  "press.open": "Öffnen",
  "slack.modal.change": "Auswahl ändern",
  "slack.modal.changeSubmit": "Ändern",
  "slack.modal.answer": "Antwort",
  "slack.modal.when": "Andere Zeit",
  "slack.modal.what": "Anders formulieren",
  "slack.modal.answerLabel": "Deine Antwort",
  "slack.modal.currencyLabel": "Währung",
  "slack.modal.whenLabel": "Wann passt es",
  "slack.modal.whatLabel": "Wie es lauten soll",
  "slack.modal.submit": "Senden",
  "slack.modal.close": "Abbrechen",
  "slack.modal.empty": "Noch nichts geschrieben.",
  "press.salaryUnread": "Nicht verstanden: bitte eine Jahresuntergrenze, etwa 70k oder 70000 GBP.",
  "slack.modal.why": "Passt nicht",
  "slack.modal.reasonsLabel": "Was nicht passt (optional)",
  "slack.modal.whyLabel": "Ein Satz, damit ich lerne (optional)",
  "slack.noModal": "Das Eingabefeld ließ sich gerade nicht öffnen; bitte auf der Website antworten.",
  "slack.noReason": "Als „Passt nicht“ gespeichert; nach einem Grund konnte ich nicht fragen.",
  "slack.notRewritten": "Gespeichert, aber die Nachricht oben ließ sich nicht aktualisieren; ihre Buttons sind vielleicht noch da.",
  "slack.openSite": "Website öffnen",
  // Connect Slack, and what a slack row is sent (#256, PR2).
  "me.set.ch.slackLede": "Nachrichten kommen als Slack-DM mit Buttons zum Antworten; verbinden heißt einmal auf Slacks Seite freigeben.",
  "me.set.ch.connectSlack": "Slack verbinden",
  "me.set.ch.slackUnavailable": "Für diese Installation ist keine Slack-App eingerichtet; noch nichts zu verbinden.",
  "me.set.ch.slack.connected": "Verbunden. In Slack sollte eine DM angekommen sein.",
  "me.set.ch.slack.err.oauth": "Slack hat kein Token herausgegeben; nicht verbunden. Noch einmal versuchen.",
  "me.set.ch.slack.err.state": "Diese Freigabe wurde nicht von diesem Browser gestartet; nicht verbunden. Noch einmal „Slack verbinden“ drücken.",
  "me.set.ch.slack.err.client": "Für diese Installation ist keine Slack-App eingerichtet.",
  "me.set.ch.slack.err.exists": "Dieses Konto hat schon ein Slack; zum Wechseln erst das jetzige entfernen.",
  "me.set.sub.title": "Was hier ankommt",
  "me.set.sub.today": "Neue Stellen des Tages",
  "me.set.sub.interviews": "Interviewvorbereitung fertig",
  "me.set.sub.asks": "Fragen an dich",
  "me.set.sub.reports": "Berichte und Leads",
  "me.set.sub.account": "Konto und Probewoche",
  "slack.connected": "Verbunden. Neue Stellen, Fragen an dich, Berichte und Leads sowie die Interviewvorbereitung kommen ab jetzt hierher, mit Buttons zum Antworten.",
  "privacy.choice.off": "Diese Seite zeichnet im Browser derzeit nichts auf, deshalb wirst du nicht gefragt.",
  "me.set.analytics.browserOff": "Was dein Browser aufzeichnet: für diese Seite derzeit nicht eingeschaltet.",
  // #788 PR2: the question, the privacy page, the settings card, the error page.
  "consent.title": "Hilfst du uns, das hier besser zu machen?",
  "consent.body": "Wenn du zustimmst, notiert dein Browser, welche Seiten du hier öffnest, wie lange du bleibst, welche Bedienelemente du nutzt und wo etwas schiefgeht. Nichts, was du schreibst, kein Arbeitgeber und keine Stelle, die du ansiehst, und weder dein Name noch deine E-Mail-Adresse werden notiert. Ein Nein ändert nichts daran, was du hier tun kannst.",
  "consent.change": "Du kannst das jederzeit unter Mein Profil → Einstellungen → Nutzungsstatistik ändern.",
  "consent.more": "Details",
  "consent.yes": "Zustimmen",
  "consent.no": "Nicht zustimmen",
  "privacy.title": "Datenschutz und Nutzungsstatistik",
  "privacy.lede": "Was wir aufzeichnen, um das Produkt zu verbessern, was nie, und wie du wählst.",
  "privacy.server.h": "Was unser Server aufzeichnet",
  "privacy.server.p": "Wenn du hier etwas tust – einen Onboarding-Schritt beantwortest, eine Einstellung speicherst, eine Nachricht sendest –, notiert der Server, welche Art von Aktion es war, ob sie geklappt hat und wie lange sie dauerte; bei Hintergrundarbeit (Lebenslauf lesen, erste Suche, Bericht) wie lange sie dauerte und ob sie geklappt hat. Das sind Anfragen, die du uns ohnehin schickst; du kannst es unter Mein Profil → Einstellungen ausschalten.",
  "privacy.browser.h": "Was dein Browser aufzeichnet",
  "privacy.browser.p": "Nur wenn du zustimmst: welche Seiten du öffnest (die Art der Seite, etwa „Seite einer Stelle“, nie welche), wie lange sie vor dir lag, welche Bedienelemente du nutzt und wo auf dem Bildschirm etwas schiefging.",
  "privacy.never.h": "Nie in der Nutzungsstatistik",
  "privacy.never.p": "Alles, was du schreibst, dein Lebenslauf, welcher Arbeitgeber oder welche Stelle, die tatsächliche Adresse einer Seite, deine IP-Adresse und Angaben zu deinem Browser. Die Aufzeichnungen tragen keinen Namen, keine E-Mail-Adresse und keine Konto-ID – nur einen aus deinem Konto berechneten Code.",
  "privacy.where.h": "Wo und wie lange",
  "privacy.where.p": "Aufzeichnungen werden gebündelt in unseren eigenen Dateispeicher geschrieben – nicht in die Datenbank und nie an Werbetreibende. Sobald eine Analyseplattform angebunden ist, werden sie nach dem Import aus unserem Speicher gelöscht; dort werden sie höchstens 730 Tage aufbewahrt.",
  "privacy.source.h": "Woher du kommst",
  "privacy.source.p": "Kommst du zum ersten Mal über einen Link mit Kampagnen-Markierungen oder von einer anderen Website, speichern wir den Namen dieser Website, die Markierungen und die Art der Seite, auf der du gelandet bist, 30 Tage lang in einem Cookie; registrierst du dich, werden sie bei deinem Konto gespeichert und das Cookie wird entfernt. Nie die Adresse der Seite, die dich geschickt hat.",
  "privacy.choice.h": "Deine Wahl",
  "privacy.choice.granted": "Dieser Browser jetzt: der Aufzeichnung im Browser zugestimmt.",
  "privacy.choice.denied": "Dieser Browser jetzt: der Aufzeichnung im Browser nicht zugestimmt.",
  "privacy.choice.none": "Dieser Browser hat noch nicht gewählt.",
  "privacy.choice.server": "Die Aufzeichnung auf dem Server schaltest du unter Mein Profil → Einstellungen aus.",
  "me.set.analytics.title": "Nutzungsstatistik",
  "me.set.analytics.lede": "Damit wir sehen, wie das hier genutzt wird, was langsam ist und was kaputtgeht, und es verbessern. Nichts, was du schreibst, kein Arbeitgeber, keine Stelle und nicht dein Name wird aufgezeichnet.",
  "me.set.analytics.server": "Was unser Server aufzeichnet",
  "me.set.analytics.what.server": "Welche Art von Aktion, ob sie geklappt hat, wie lange sie dauerte. Aus: dafür wird für dich nichts mehr aufgezeichnet.",
  "me.set.analytics.browser": "Was dieser Browser aufzeichnet",
  "me.set.analytics.what.browser": "Geöffnete Seiten, Zeit darauf, genutzte Bedienelemente, was schiefging. Gilt nur für diesen Browser.",
  "me.set.analytics.more": "Details",
  "error.title": "Auf dieser Seite ist etwas schiefgegangen",
  "error.body": "Die Seite konnte nicht angezeigt werden. Versuch es mit Neuladen.",
  "error.retry": "Neu laden",
};
